import React, { Component } from 'react';
import CustomModal from './index';
import { ColorButton, MultiselectDropdown, ReceiptDetailModal } from '../../../../index';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import Help from '../../../../../assets/images/module/general/Help.svg';
import TrashIcon from '../../../../../assets/images/module/general/TrashIcon.svg';
import downArrow from '../../../../../assets/images/module/general/SelectArrowDown.svg';
import uparrow from '../../../../../assets/images/module/general/SelectArrowUp.svg';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Autoload from '../../../../Autoload';
import { requestHeatingCostSplit } from '../../../../../helpers/heatingCostSplit';
import GlobalServices from '../../../../helpers/services/GlobalServices';
import moment from 'moment';
import { toast } from 'react-toastify';
import APIClient from '../../../../config/APIClient';
import { config } from '../../../../config/Setting';
import AlertModal from './AlertModal';
import { formatNumber, formatNumberByLocale } from '../../../../../helpers/stringsManipulations';
import { showNotification } from '@mantine/notifications';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import UpRightArrow from '../../../../../assets/images/module/general/UpRightArrow.svg';
import { NumericFormat, numericFormatter } from 'react-number-format';
import { Checkbox, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip as TooltipMaterialUI } from '@material-ui/core';
import {
  changeCurrentProperty,
  setRunUpdateHeatingCostSplit
} from '../../../../../redux/action/General/generalActions';
import accounting from 'accounting';
import { Group, Loader, Tooltip as TooltipMantine, Skeleton } from '@mantine/core';
import AddHeatingCostModal from './AddHeatingCostModal';
import dayjs from 'dayjs';
import EditVatAndLabourAmount from './EditVatAndLabourAmount';
import ReceiptAssigmentRemoveConfirmationForCpAmountModal from './ReceiptAssigmentRemoveConfirmationForCpAmountModal';
import ReceiptAssigmentRemoveConfirmationModal from './ReceiptAssigmentRemoveConfirmationModal';
import SelectReceiptsForReceiptAssigmentModal from './SelectReceiptsForReceiptAssigmentModal';
import ReceiptAssigmentRemoveConfirmationForCpDeleteModal from './ReceiptAssigmentRemoveConfirmationForCpDeleteModal';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const {
  checkProperty,
  emptyFieldValidation,
  redirection,
  invalidSize,
  loader,
  ConverterLocaleNumber,
  ConverterCurrencyDe,
} = Autoload.MainHelper;

const DragHandle = SortableHandle(() => (
  <IconButton className='custom-icon-button' style={{ padding: '4px' }}>
    <DragIndicatorIcon style={{ fontSize: '18px' }} />
  </IconButton>
));

const SortableTableRow = SortableElement(({ content }) => content);

const SortableTableBody = SortableContainer(({ children }) => {
  return <TableBody>{children}</TableBody>;
});

class HeatingCostModal extends Component {
  initialState = {
    errMsg: false,
    totalCost: {
      value: '',
      msg: '',
      err: false,
    },
    amount: {
      value: '',
      msg: '',
      err: false,
    },
    unitAmount: {
      value: '',
      msg: '',
      err: false,
    },
    dropdownStateOne: 'true',
    dropdownStateTwo: 'true',
    costPositions: [],
    cpOptions: [],
    receiptsDropDown: [],
    selectedReciptsArr: [],
    oldSelectedReceipt: [],
    receiptDeleted: [],
    receiptAdded: [],
    energyOptions: [],
    selectedEnergy: {
      fuelTypeName: '',
      conversionkWh: '',
      conversionCO2EmissionskgBykWh: null,
    },
    selectedEnergyErr: false,
    selectedAllocation: {
      allocationKeyName: '',
      conversionkWh: '',
    },
    selectedAllocationErr: false,
    receipts: [],
    allocationOptions: [],
    checkboxone: false,
    openAlert: false,
    openDataFehlen: false,
    openRedirectAlert: false,
    totalCostInFocus: false,
    energyConsumptionInFocus: false,
    waterHeatConsumptionInFocus: false,
    totalCO2Emissions: null,
    isCO2TaxActivated: true,
    addHeatingCostModalOpen: false,
    billingPeriod: null,
    isCO2TaxMainlyUsedForBusiness: false,
    isCO2TaxPreservationObject: false,
    heatedFloorSpace: null,
    heatedFloorSpaceInFocus: false,
    co2TaxReturnLandlordShareSystemId: null,
    heatingCostsLoader: false,
    heatingCostHover: null,
    propertyData: null,
    addHeatingCostModalCostPositionId: null,
    openEditVatAndLabourAmount: false,
    selectedHCPforVATlabourEdit: null,
    currentCp: null,
    addHeatingCostPositionLoader: false,
    previousAmount: null,
    previousVatAmount: null,
    previousLaborCost: null,
    newAmount: null,
    newVatAmount: null,
    newLaborCost: null,
    openRemoveReceiptAssignmentForCpAmountModal: false, 
    openRemoveReceiptAssignmentModal: false,
    selectedHCPforAmountEdit: null,
    runUpdateReceiptAssignmentsByCostPositionId: null,
    selectReceiptsForReceiptAssigmentModalOpen: false,
    selectedReceiptsForReceiptAssignments: [],
    selectedHeatingCostForReceiptAssignments: null,
    receiptsLoader: false,
    resetValuesToDefault: false,
    openRemoveReceiptAssignmentForCpDeleteModal: false,
    selectedHeatingCostPositionForDeletionId: null,
    selectedHeatingCostPositionAssignedReceiptsForDeletion: [],
    co2EmissionErr: false,
    loadingRowIds: []
  };

  form=null;

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }
  componentDidMount() {
    const { cpId, billingPeriodId, propertySelected } = this.props;
    console.log('cpId: ', cpId);
    this.costTypeId = cpId.costTypeId;
    this.costPositionId = cpId.id;
    this.billingPeriodId = billingPeriodId;
    loader(true);
    this.setState({
      totalCost: {
      ...this.state.totalCost,
      value: cpId.amount,
      },
      heatedFloorSpace: propertySelected?.heatedFloorSpace
    },()=> {
      this.getProperty();
      this.getCpOptions();
      this.getTotalCost();
      this.getEnergyOptions();
      this.getAllocationOptions();
      //this.getAllByBillingPeriodCostType(this.billingPeriodId, this.costTypeId);
      //this.getSelectedReceipts();
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps && this.props.editReceiptOpen === false) {
      //this.getAllByBillingPeriodCostType(this.billingPeriodId, this.costTypeId);
    }
  }

  getProperty() {
    const propertyID = this.props.propertySelected.id;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyID,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_property_data',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_get_property_data(response){
    if(response.status && response.statuscode === 200){
      this.setState({propertyData: response.result});
    }
  }

  getAllByBillingPeriodHeatingCostType = async (billingPeriodId, heatingCostPositions, callBackFunction = () => null) => {
    if (heatingCostPositions.length > 0) {
      try {
        // 1. Create an array of all the API call promises
        const requests = heatingCostPositions.map((heatingCostPosition) => 
          APIClient({
            method: 'GET',
            url: config.receipt + "getAllBy?billingPeriodId=" + billingPeriodId + "&heatingCostType=" + heatingCostPosition.heatingCostTypeName,
            headers: {
              "Content-Type": "application/octet-stream",
              "Authorization": Autoload.Utils.getAuthToken(),
            }
          })
        );

        // 2. Wait for all requests to finish successfully
        const responses = await Promise.all(requests);
        let allReceipts = [];

        // 3. Loop through the resolved responses and format them
        responses.forEach((response) => {
          if (response.data && response.data.result && response.data.result.length > 0) {
            const formattedReceipts = response.data.result.map((receipt) => {
              // Avoid mutating the original object directly
              let rec = { ...receipt }; 
              rec.receiptDate = moment(receipt.receiptDate).format('DD.MM.YYYY');
              return rec;
            });
            allReceipts.push(...formattedReceipts);
          }
        });

        // 4. Call setState exactly once with the complete data
        this.setState({ receipts: allReceipts }, () => callBackFunction());

      } catch (error) {
        console.log("getAllByBillingPeriodHeatingCostType: ", error);
      }
    } else {
      // Ensure the callback still runs if the array is empty
      callBackFunction(); 
    }
  }

  _handleReceiptsDropDownResponse = (response) => {
    if (response.status === false) {
      Autoload.Redirection.redirection_error();
      // Autoload.DataHandlerGeneral.GeneralErrorMessage(true, 'Receipts not found against this property!');
    }

    if (response.result.length > 0) {
      let formattedArr = response.result
        .filter((receipt) => checkProperty(receipt, 'utilityBillingRelevant') == true)
        .map((receipt) => ({
          id: checkProperty(receipt, 'receiptId'), // id
          receiptName: checkProperty(receipt, 'name'),
          date: moment(checkProperty(receipt, 'receiptDate')).format('DD.MM.YYYY'),
          // date: moment(checkProperty(receipt, 'date')).format('DD.MM.YYYY'),
          proRataDays: 123,
        }));

      this.setState({
        receiptsDropDown: formattedArr,
      });
    }
  };

  getHeatingCosts = (addEmptyHC = false, isBackground = false) => {
    // loader(true);
    if (!isBackground) {
      this.setState({ heatingCostsLoader: true });
    }
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCosts?utilityBillingId=' + this.props.currentDataId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleHeatingCostsResponse',
      { addEmptyHC },
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  _handleHeatingCostsResponse = (response) => {
    console.log('_handleHeatingCostsResponse: ', response.result);
    if (!response.status) {
      Autoload.Redirection.redirection_error();
    }

    if (response.result.length > 0) {
      let formatted = response.result.map((hc, i) => {
        const existingCP = this.state.costPositions.find(cp => String(cp.id) === String(checkProperty(hc, 'id')));
        
        return ({
          id: checkProperty(hc, 'id'),
          err: false,
          msg: '',
          heatingCost: hc.heatingCost,
          heatingCostType: checkProperty(hc, 'heatingCostType'),
          systemHeatingCostTypeId: hc.systemHeatingCostTypeId,
          displayOrder: checkProperty(hc, 'displayOrder'),
          vatAmount: hc.vatAmount,
          laborCost: hc.laborCost,
          assignedReceipts: existingCP && existingCP.assignedReceipts ? [...existingCP.assignedReceipts] : [],
          receiptsLoaded: existingCP && existingCP.receiptsLoaded ? true : false
        })
      });
      console.log('formatted: ', formatted);
      this.setState({ costPositions: formatted, loadingRowIds: [] }, () => {
        this.calculateTotalOnAmountChange();
        loader(false);
        if (response.other.addEmptyHC) this.addEmptyHeatingCost();
        
        formatted.forEach((cp) => {
            if (!cp.receiptsLoaded) {
                this.getSelectedReceipts(cp.id);
            }
        });
      });
    } else {
      this.setState({ costPositions: this.state.costPositions.filter((i) => i === 0), loadingRowIds: [] }, () => loader(false));
    }

    this.setState({heatingCostsLoader: false}, ()=> setTimeout(() => {
      this.postCO2TaxReimbursementValue();
    }, 500));
  };

  getCpOptions = () => {
    this.setState({heatingCostsLoader: true});
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCostSystemTypes?propertyId='+this.props.propertySelected.id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleCpOptionsResponse',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  _handleCpOptionsResponse = (response) => {
    if (response.status === false) {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_utility_error);
    }
    this.setState({ cpOptions: Array.isArray(response.result) ? response.result : [], co2TaxReturnLandlordShareSystemId: response.result.find((systemHeatingCost)=> systemHeatingCost.heatingCostTypeName === "CO2-Steuer Erstattung Vermieteranteil")?.id }, () => loader(false));
    //response.result.map((heatingCostPosition)=> this.getAllByBillingPeriodCostType(this.billingPeriodId, heatingCostPosition.id));
    this.getAllByBillingPeriodHeatingCostType(this.billingPeriodId, response.result)
    this.getHeatingCosts();
  };

  getSelectedReceipts = (costPositionId=null) => {
    console.log('getSelectedReceipts: ', costPositionId);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'receiptAssignments?costPositionId=' + (costPositionId ? costPositionId : this.props.cpId.id),
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleSelectedReceiptsResponse',
      {costPositionId},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  _handleSelectedReceiptsResponse = (response) => {
    if (response.status === false && response.message !== 'Not Found') {
      Autoload.Redirection.redirection_error();
    }
    
    // Case 1: Receipts Found (200 OK)
    if(response.status && response.statuscode === 200){
      
      this.setState(prevState => {
        const updatedCostPositions = prevState.costPositions.map((cp) => {
          if (String(cp.id) === String(response.other.costPositionId)) {
            
            const newCp = { ...cp };

            const newReceiptAssignmentsFound = response.result.filter((newReceiptAssignment) => 
              !newCp.assignedReceipts.some((existing) => existing.id === newReceiptAssignment.id)
            );

            if (newReceiptAssignmentsFound.length > 0) {
              newCp.assignedReceipts = [...newCp.assignedReceipts, ...newReceiptAssignmentsFound];
            }

            if (this.state.currentCp && String(newCp.id) === String(this.state.currentCp.id)) {
              this.setState({
                selectedReceiptsForReceiptAssignments: this.state.receipts.filter((receipt) => 
                  newCp.assignedReceipts.find((selected) => (selected.costPositionId === response.other.costPositionId && selected.receiptId === receipt.id))
                )
              });
            }
            
            // Mark as loaded
            newCp.receiptsLoaded = true;
            return newCp;
          }
          return cp;
        });

        return { costPositions: updatedCostPositions, receiptsLoader: false };
      });

    // Case 2: No Receipts Found (404)
    } else if(response.statuscode === 404){
      
      this.setState(prevState => {
        const updatedCostPositions = prevState.costPositions.map((cp) => {
          if (String(cp.id) === String(response.other.costPositionId)) {
            return { ...cp, assignedReceipts: [], receiptsLoaded: true };
          }
          return cp;
        });
        return { costPositions: updatedCostPositions, receiptsLoader: false };
      });
    } else {
       this.setState({receiptsLoader: false});
    }
  }

  updateCostSplit = () => {
    requestHeatingCostSplit(this.props.currentDataId, (response) => this.updateHeatingCostSplit(response));
  };
  updateHeatingCostSplit(response) {
    !response.status && console.log('Update Consumptions Failed');
    window.open(window.location.href, '_self');
    this.resetForm();
  }
  getTotalCost = () => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'utilityBillings/' + this.props.currentDataId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetUtilityResponse',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  _handleGetUtilityResponse(response) {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_utility_not_found);
    }
    this.setState(
      {
        selectedEnergy: this.props.propertySelected.energyFuelType,  
        selectedAllocation: this.props.propertySelected.centralWarmWaterAllocationKey,
        checkboxone: response.result.hasCentralWarmWaterAmount ? false : true,
        unitAmount: {
          ...this.state.unitAmount,
          value: this.props.propertySelected.centralWarmWaterAllocationKey && response.result.energyAmountWarmWater ? response.result.energyAmountWarmWater : null,
        },
        amount: {
          ...this.state.amount,
          value: response.result.heatingEnergyAmount ? response.result.heatingEnergyAmount : null,
        },
        utilityBillingData: response.result,
        totalCO2Emissions: response.result.totalCO2Emissions,
        isCO2TaxActivated: response.result.isCO2TaxActivated,
        billingPeriod: response.result.billingPeriod,
        isCO2TaxMainlyUsedForBusiness: response.result.isCO2TaxMainlyUsedForBusiness,
        isCO2TaxPreservationObject: response.result.isCO2TaxPreservationObject
      },
      () => loader(false)
    );
  }

  getEnergyOptions = () => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'systemFuelTypes',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetEnergyOptions',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  _handleGetEnergyOptions = (response) => {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_system_fuel_not_found);
    }

    this.setState({ energyOptions: response.result }, () => loader(false));
  };

  getAllocationOptions = () => {
    GlobalServices._getAllocationKeysByProperty(this, '_handleGetAllocationOptions', this.props.propertySelected);
  };
  _handleGetAllocationOptions = (response) => {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_system_fuel_not_found);
    }

    this.setState({ allocationOptions: response.result.filter((allocationKey)=> allocationKey.meterType !== 'PROPERTY') }, () => loader(false));
  };

  renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Bitte geben Sie hier die Gesamtsumme Ihrer Heizkosten ein oder fügen Sie einzelne Positionen Ihrer Heizkosten
      hinzu
    </Tooltip>
  );
  renderEnergyTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Tragen Sie hier die Gesamtmenge des verbrauchten Brennstoffs ein.
    </Tooltip>
  );
  renderWärmemengeWarmwasserboilerTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Tragen Sie hier die Gesamtwärmemenge des zentralen Warmwasserboilers ein.
    </Tooltip>
  );
  onInputChange = (field, value) => {
    this.setState({ [field]: { ...this.state[field], value: value, err: false } });
  };

  onCreateReceiptSelect=(id, costPositionId=null)=>{
    setTimeout(() => {
      this.setState({receiptsLoader: true}, () => {
        const foundReceipt = this.state.receipts.find((receipt) => receipt.id === id);
        
        if (foundReceipt !== undefined) {
          this.onReceiptSelect('', foundReceipt, costPositionId);
        } else {
          // Fallback: If receipt isn't found, kill the loader to prevent infinite spinning
          this.setState({ receiptsLoader: false });
        }
      });
    }, 1000);
  }

  onReceiptSelect = (selectedList, selectedItem, costPositionId=null) => {
    if(selectedItem !== undefined){
      let selectedCostPosition= this.state.costPositions.find((cp)=> cp.id === costPositionId);
      if(selectedCostPosition){
        this.setState({runUpdateReceiptAssignmentsByCostPositionId: selectedCostPosition.id, heatingCostsLoader: true}, ()=> this.updateReceipt(selectedItem, true));
      }
    }
  };
  _handlePostReceipt = (response) => {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
    }
    this.updateReceiptAssignmentsByCostPositionId();
    //this.getSelectedReceipts(response.other.costPositionId);
    loader(false);
  };

  onReceiptRemove = (selectedList, removedItem, costPositionId) => {
    //loader(true);
    console.log('selectedList: ', removedItem);
    let selectedCostPosition= this.state.costPositions.find((cp)=> cp.id === costPositionId);
    if(this.state.receipts.filter((receipt) => selectedCostPosition.assignedReceipts.find((selected) => (selected.costPositionId === selectedCostPosition.id && selected.receiptId === receipt.id))).length > 0 && this.state.receipts.find((receipt) => receipt.id === removedItem.receiptId) !== undefined){
      this.setState({openRemoveReceiptAssignmentModal: true, runUpdateReceiptAssignmentsByCostPositionId: selectedCostPosition.id, removedItems: [this.state.receipts.find((receipt) => receipt.id === removedItem.receiptId)]});
    }else{
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'receiptAssignments/' + removedItem.id,//receipt.id,
        'DELETE',
        null,
        null,
        false,
        true,
        false,
        this,
        '_handleDeleteReceipt',
        {costPositionId},
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }
  };
  _handleDeleteReceipt(response) {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
    }
    // console.log('response of delete receipt', response)
    this.getSelectedReceipts(response.other.costPositionId);
    loader(false);
  }

  addEmptyHeatingCost = () => {
    loader(true);
    let oldArr = this.state.costPositions;
    oldArr.push({
      id: 0,
      err: false,
      msg: '',
      heatingCost: '0,00 €',
      heatingCostType: this.state.cpOptions.length > 0 ? this.state.cpOptions[0].heatingCostTypeName : '',
      systemHeatingCostTypeId: this.state.cpOptions.length > 0 ? this.state.cpOptions[0].id : null,
      displayOrder: this.state.costPositions.length + 1,
      vatAmount: null,
      laborCost: null
    });
    this.setState({ costPositions: oldArr }, () => loader(false));
  };
  onCpChange = (field, id, value, onBlur=true) => {
    let oldSelectedHeatingCostType= null;
    let updatedArr = this.state.costPositions.map((arr) => {
      if (arr.id === id) {
        if(field === 'heatingCostType'){
          oldSelectedHeatingCostType= arr.heatingCostType;
        }
        return {
          ...arr,
          [field]: field === 'heatingCostType' ? value.heatingCostTypeName : value,
          systemHeatingCostTypeId: field === 'heatingCostType' ? value.id : arr.systemHeatingCostTypeId
        };
      } else {
        return arr;
      }
    });
    console.log('oldSelectedHeatingCostType: ', oldSelectedHeatingCostType?.length);
    this.setState({ costPositions: updatedArr }, ()=> {
      if(onBlur){
        let cpPutData = this.state.costPositions
        .filter((i) => i.id !== 0)
        .map((cp) => ({
          id: cp.id,
          heatingCostType: cp.heatingCostType,
          heatingCost: typeof cp.heatingCost === 'number' ? cp.heatingCost : Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost ? cp.heatingCost : 0),
          systemHeatingCostTypeId: cp.systemHeatingCostTypeId,
          heatingCostTypeName: cp.heatingCostType,
          displayOrder: cp.displayOrder,
          vatAmount: cp.vatAmount,
          laborCost: cp.laborCost
        }));
        if (cpPutData.length) {
          this.setState(prevState => ({ loadingRowIds: [...prevState.loadingRowIds, id] }));
          // [FIX] Pass the specific ID if we are changing type
          this.putHeatingCosts(cpPutData, field === 'heatingCostType', field === 'heatingCostType' ? id : null);
        }
      }
    });
  };

  addHeatingCost = (isValidatedPost = false, addNewHeatingCost=false, heatingCostName=null) => {
    loader(true);

    let body = this.state.costPositions.find((i) => i.id === 0),
      validated = false,
      error = { err: false, msg: '' };
    console.log('addHeatingCost: ', body, body && (body.heatingCostType !== '' || body.heatingCost !== '') && Autoload.MainHelper.convertCurrencyToNumber(body.heatingCost));
    if (body && (body.heatingCostType !== '' || body.heatingCost !== '') && (Autoload.MainHelper.convertCurrencyToNumber(body.heatingCost) === 0 || Autoload.MainHelper.convertCurrencyToNumber(body.heatingCost))) {
      validated = true;
    } else error = { err: true, msg: lang.newKeys.text_heating_cost_type_error_msg };

    if (validated || isValidatedPost) {
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'heatingCosts',//?utilityBillingId=' + this.props.currentDataId,
        'POST',
        { 
          heatingCostType: addNewHeatingCost ? heatingCostName : body.heatingCostType, 
          heatingCostTypeName: addNewHeatingCost ? heatingCostName : body.heatingCostType, 
          heatingCost: addNewHeatingCost ? 0 : body.heatingCost, 
          systemHeatingCostTypeId: addNewHeatingCost ? null : body.systemHeatingCostTypeId ? body.systemHeatingCostTypeId : null,
          displayOrder: addNewHeatingCost ? (this.state.costPositions[this.state.costPositions.length - 1].displayOrder + 1) : body.displayOrder,
          utilityBillingId: this.props.currentDataId,
          propertyId: this.props.propertySelected?.id,
          vatAmount: null,
          laborCost: null
        },
        null,
        false,
        true,
        false,
        this,
        'handleHeatingCostsPostResponse',
        { isValidatedPost, addNewHeatingCost },
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    } else {
      if (body) {
        this.setState(
          {
            costPositions: this.state.costPositions.map((i) => {
              if (i.id === body.id) return { ...i, ...error };
              else return i;
            }),
          },
          () => {
            loader(false);
          }
        );
      } else this.addEmptyHeatingCost();
    }
  };
  handleHeatingCostsPostResponse(response) {
    if (response.status) {
      if (!response.other.isValidatedPost) {
        response.other.addNewHeatingCost && this.getCpOptions();
        this.getHeatingCosts(true);
      }
    } else {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_adding_heat_cost);
      loader(false);
    }
  }

  deleteHeatingCost = (id) => {
    loader(true);
    if (id) {
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'heatingCosts/' + id,
        'DELETE',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleDeleteCostPosition',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    } else {
      let updatedArr = this.state.costPositions.filter((arr) => arr.id !== id);
      this.setState({ costPositions: updatedArr }, () => {
        this.calculateTotalOnAmountChange();
        loader(false);
      });
    }
  };
  handleDeleteCostPosition(response) {
    if (response.status) {
      this.getHeatingCosts();
      this.getCpOptions();
    } else {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_delete_heat_cost);
      loader(false);
    }
  }

  calculateTotalOnAmountChange = () => {
    const {isCO2TaxActivated, co2TaxReturnLandlordShareSystemId} = this.state;
    // console.clear()
    let sumOfAmounts = 0;

    this.state.costPositions.filter((cp)=> isCO2TaxActivated === false ? cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId : cp).forEach((arr) => {
      console.log(arr)
      //console.log(arr.heatingCost.replace('.', '').replace(',', '.').split('€')[0] * 1)
      // console.log('each value', Autoload.MainHelper.ConverterLocaleNumber(arr.heatingCost, 'de'), sumOfAmounts);
      sumOfAmounts = sumOfAmounts + (arr.heatingCost * 1);
    });
    console.log(sumOfAmounts)
    console.log(Autoload.MainHelper.convertToCurrencyFromNumber(sumOfAmounts, true))
    // console.log('total cost cal', sumOfAmounts, Autoload.MainHelper.ConverterCurrencyDe(sumOfAmounts + '', true));
    this.setState({
      totalCost: {
        ...this.state.totalCost,
        value: sumOfAmounts,
      },
    });
  };
  onAmountBlur = (field, id, value) => {
    console.log('onblur', value);
    let updatedArr = this.state.costPositions.map((arr) => {
      if (arr.id === id) {
        return {
          ...arr,
          [field]: value,
        };
      } else {
        return arr;
      }
    });
    this.setState({ costPositions: updatedArr, selectedHCPforAmountEdit: null, newAmount: null }, () => {
      this.calculateTotalOnAmountChange();
      
      let cpPutData = this.state.costPositions
      .filter((i) => i.id !== 0)
      .map((cp) => ({
        id: cp.id,
        heatingCostType: cp.heatingCostType,
        // [FIX] Don't convert if it's already a number
        heatingCost: typeof cp.heatingCost === 'number' ? cp.heatingCost : Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost ? cp.heatingCost : 0),
        systemHeatingCostTypeId: cp.systemHeatingCostTypeId,
        heatingCostTypeName: cp.heatingCostType,
        displayOrder: cp.displayOrder,
        vatAmount: cp.vatAmount,
        laborCost: cp.laborCost
      }));
      if (cpPutData.length) {
        this.setState(prevState => ({ loadingRowIds: [...prevState.loadingRowIds, id] }));
        this.putHeatingCosts(cpPutData);
      }
    });
  };
  validateCp = (data, field, fieldName, arr) => {
    let invalidErr, emptyErr;
    emptyErr = emptyFieldValidation(data[field]);
    invalidErr = invalidSize(data[field]);
    if (emptyErr) {
      let updatedSingleRecord = { ...data, err: true, msg: `${lang.general.text_enter} ${fieldName}` };
      let updatedRecord = arr.map((rc) => {
        if (rc.id == updatedSingleRecord.id) {
          return updatedSingleRecord;
        } else {
          return rc;
        }
      });
      this.setState({ data: updatedRecord });
      return true;
    } else if (invalidErr) {
      let updatedSingleRecord = { ...data, err: true, msg: `${lang.general.text_invalid} ${fieldName}` };
      let updatedRecord = arr.map((rc) => {
        if (rc.id == updatedSingleRecord.id) {
          return updatedSingleRecord;
        } else {
          return rc;
        }
      });
      this.setState({ data: updatedRecord });
      return true;
    } else {
      let updatedSingleRecord = { ...data, err: false, msg: '' };
      let updatedRecord = arr.map((rc) => {
        if (rc.id == updatedSingleRecord.id) {
          return updatedSingleRecord;
        } else {
          return rc;
        }
      });
      this.setState({ data: updatedRecord });
      return false;
    }
  };

  checkCO2EmissionEmpty = () => {
    const { totalCO2Emissions, selectedEnergy } = this.state;
    if(totalCO2Emissions === null || totalCO2Emissions === undefined || isNaN(totalCO2Emissions)){
      return true;
    }else{
      return false;
    }
  }
  //use this function on submit when need validations
  handleSubmit = async (e) => {
    e.preventDefault();
    const { costPositions, selectedEnergy, totalCO2Emissions, isCO2TaxActivated } = this.state;
    const {isMobile, isTablet} = this.props;
    let errors = [];
    let err;
    for (let i = 0; i < costPositions.length; i++) {
      err = await this.validateCp(costPositions[i], 'heatingCost', 'amount', costPositions);
      errors.push(err);
    }
    let isInvalid = errors.find((item) => item == true);
    if (isInvalid) {
      //alert('invalid heating cost data');
      this.setState({ errMsg: err });
    } else {
      // if (Setting.UB_debug) {
      let errs = [];
      let totalCostErr,
        energyErr = false,
        allocationErr = false,
        co2EmissionErr = false;

      if(isCO2TaxActivated && this.checkCO2EmissionEmpty()){
        co2EmissionErr = true;
        this.setState({co2EmissionErr});
      }

      if(co2EmissionErr){
       return;
      }
      // if (this.state.costPositions.length === 0) {
      //   cpErr = true;
      //   errs.push('cost positions');
      // }
      console.log('this.state.totalCost.value: ',this.state.totalCost.value);
      if (this.state.totalCost.value === null || this.state.totalCost.value === 0 || this.state.totalCost.value === undefined || this.state.totalCost.value === '') {
        totalCostErr = true;
        this.setState({totalCost: {
          ...this.state.totalCost,
          msg: 'Summe Heizkosten',
          err: true
        }})
        errs.push('Summe Heizkosten');
      }
      console.log('this.state.amount.value: ', this.state.amount.value);
      if ((this.state.amount.value === null || this.state.amount.value === undefined) ||
        (this.state.selectedEnergy.id === '' ||
        this.state.selectedEnergy.fuelTypeName === '' ||
        this.state.selectedEnergy.conversionkWh === '')
      ) {
        console.log('this.state.amount.value: ', this.state.amount.value === null);
        energyErr = true;
        errs.push('Energieverbrauch');
        this.setState({
          amount: {
            ...this.state.amount,
            msg: 'Verbrauch erforderlich',
            err: this.state.amount.value === null || this.state.amount.value === undefined ? true : false
          },
          selectedEnergyErr: (this.state.selectedEnergy === null || this.state.selectedEnergy === undefined || this.state.selectedEnergy.fuelTypeName === '') ? true : false
        })
      }
      console.log('this.state.unitAmount.value: ', this.state.unitAmount.value);
      if (
        this.props.propertySelected.heatingType === 'central with warm water' &&
        (this.state.selectedAllocation === null ||
        this.state.selectedAllocation?.allocationKeyId === '' ||
        //this.state.selectedAllocation.id === '' ||
        this.state.selectedAllocation?.allocationKeyName === '' ||
        this.state.selectedEnergy.conversionkWh === '' ||
        (this.state.unitAmount.value === null || this.state.unitAmount.value === undefined))
      ) {
        allocationErr = !this.state.checkboxone ? true : false;
        !this.state.checkboxone && errs.push('Wärmemenge Warmwasserboiler');
        !this.state.checkboxone && this.setState({
          unitAmount: {
            ...this.state.unitAmount,
            msg: 'Verbrauch erforderlich',
            err: this.state.unitAmount.value === undefined || this.state.unitAmount.value === null ? true : false
          },
          selectedAllocationErr: this.state.selectedAllocation && this.state.selectedAllocation?.allocationKeyName === '' ? true : false
        })
      }
      if(this.props.propertySelected.heatingType === 'central with warm water' && (this.state.selectedAllocation?.allocationKeyName === null || this.state.selectedAllocation?.allocationKeyName === undefined || this.state.selectedAllocation?.allocationKeyName === '') && this.state.checkboxone === false){
        showNotification({
          message: "Bitte wählen Sie einen Verteilerschlüssel für den zentralen Warmwasserboiler oder wählen Sie \"kein Verbrauch verfügbar\".",
          icon: <img src={RedCross} />
        });
        return;
      }
      if (totalCostErr || energyErr || allocationErr) {
        this.setState({openDataFehlen: true});
        return;
      }else{
        setTimeout(() => {
          this.saveData(e);
        }, 600);
      }
      // }
    }

    //this.saveData(e);
  };

  saveData = (e) => {
    const {propertySelected, cpId} = this.props;
    const {propertyData} = this.state;
    e.preventDefault();

    // if (Setting.UB_debug) {
    let totalCostErr,
      // cpErr,
      energyErr = false;
    let errs = [];
    // if (this.state.costPositions.length === 0) {
    //   cpErr = true;
    //   errs.push('Invalid or empty cost positions ');
    // }
    if (this.state.totalCost.value === null || this.state.totalCost.value === 0) {
      totalCostErr = true;
      errs.push('Invalid or empty total heating cost ');
    }
    if (
      this.state.selectedEnergy.id === '' ||
      this.state.selectedEnergy.fuelTypeName === '' ||
      this.state.selectedEnergy.conversionkWh === ''
    ) {
      energyErr = true;
      errs.push('Invalid or empty energy consumption');
    }
    // if (totalCostErr || energyErr) {
    //   toast.dark(`data missing: ${errs}`, {
    //     position: 'top-center',
    //     autoClose: false,
    //     className: 'neoverv-toast',
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //   });
    //   return;
    // }
    // }

    //api to save and delete recipts (could be optional)
    this.manipulateReciept();

    this.state.costPositions.filter((i) => i.id === 0).length > 0 && this.addHeatingCost(true);

    loader(true);
    //api to save cost positions
    let cpPutData = this.state.costPositions
      .filter((i) => i.id !== 0)
      .map((cp) => ({
        id: cp.id,
        heatingCostType: cp.heatingCostType,
        // [FIX] Don't convert if it's already a number
        heatingCost: typeof cp.heatingCost === 'number' ? cp.heatingCost : Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost ? cp.heatingCost : 0),
        systemHeatingCostTypeId: cp.systemHeatingCostTypeId,
        heatingCostTypeName: cp.heatingCostType,
        displayOrder: cp.displayOrder,
        vatAmount: cp.vatAmount,
        laborCost: cp.laborCost
      }));
    if (cpPutData.length) {
      console.log('heatingCosts_PUT: ', cpPutData, this.state.costPositions);
      this.putHeatingCosts(cpPutData);
    }
    // update ub data
    let utilityData = {
      ...this.state.utilityBillingData,
      //totalHeatingCost: Autoload.MainHelper.convertCurrencyToNumber(this.state.totalCost.value),
      heatingCostsAllocated: true,
      isCO2TaxActivated: this.state.isCO2TaxActivated,
      totalCO2Emissions: this.state.isCO2TaxActivated ? this.state.totalCO2Emissions !== NaN ? parseFloat(this.state.totalCO2Emissions) : null : null,
      isCO2TaxMainlyUsedForBusiness: this.state.isCO2TaxMainlyUsedForBusiness,
      isCO2TaxPreservationObject: this.state.isCO2TaxPreservationObject,
      // heatingEnergyType: {
      //   id: this.state.selectedEnergy.id,
      //   fuelTypeName: this.state.selectedEnergy.fuelTypeName,
      //   conversionkWh: Autoload.MainHelper.convertCurrencyToNumber(this.state.selectedEnergy.conversionkWh),
      // },
      hasCentralWarmWaterAmount: this.state.checkboxone ? false : true,
      energyAmountWarmWater: this.state.checkboxone ? null : this.state.unitAmount && this.state.unitAmount.value ? this.state.unitAmount.value : null,
      //centralWarmWaterAllocationKeyId: this.state.checkboxone ? '' : this.state.selectedAllocation.allocationKeyId,
      //centralWarmWaterAllocationKey: this.state.selectedAllocation
    };
    console.log(this.state.amount.value)
    utilityData.heatingEnergyAmount = this.state.amount && this.state.amount.value ? this.state.amount.value : null;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'utilityBillings/' + this.props.currentDataId,
      'PUT',
      utilityData,
      null,
      false,
      true,
      false,
      this,
      '_handleUtilityPut',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      },
      false,
      false
    );
      // update property data
    let propertyDataForUpdate= {
      ...propertyData,
      accountId: propertySelected.accountId,
      name: propertySelected.name,
      propertyAdress: {
        streetno: propertySelected.propertyAddress,
        city: propertySelected.propertyCity,
        zipCode: propertySelected.propertyZipCode,
      },
      totalRentingSpace: propertySelected.totalRentingSpace,
      numberOfRentalUnits: propertySelected.numberOfRentalUnits,
      cutOffDate: propertySelected.cutOffDate,
      heatingType: propertySelected.heatingType,
      heatingTemperature: propertySelected.heatingTemperature,
      consumptionShare: propertySelected.consumptionShare,
      receiptEmail: propertySelected.receiptEmail,
      meterReadingsEmail: propertySelected.meterReadingsEmail,
      isMeterReadingConducted: propertySelected.isMeterReadingConducted,
      propertyType: propertySelected.propertyType,
      energyFuelType: {
        id: this.state.selectedEnergy.id,
        fuelTypeName: this.state.selectedEnergy.fuelTypeName,
        conversionkWh: this.state.selectedEnergy.conversionkWh,
        conversionCO2EmissionskgBykWh: this.state.selectedEnergy.conversionCO2EmissionskgBykWh,
      },
      centralWarmwaterAllocationKey: this.state.checkboxone ? propertySelected.centralWarmWaterAllocationKey : this.state.selectedAllocation,
      //heatedFloorSpace: this.state.heatedFloorSpace,
      id: propertySelected.id,
      isConsumptionSectionHidden: propertySelected.isConsumptionSectionHidden,
      isDocumentSectionHidden: propertySelected.isDocumentSectionHidden,
      isMessageSectionHidden: propertySelected.isMessageSectionHidden,
      isPropertyOwnerInfoEnabled: propertySelected.isPropertyOwnerInfoEnabled,
      isPropertyOwnerInfoInMessagesEnabled: propertySelected.isPropertyOwnerInfoInMessagesEnabled
    };
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyDataForUpdate.id,
      'PUT',
      propertyDataForUpdate,
      null,
      false,
      true,
      false,
      this,
      '_handlePropertyPut',
      {updatePropertyData: propertyDataForUpdate},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
    //update cp data
    let payload = {
      id: cpId.id,
      utilityBillingId: this.props.currentDataId,
      amount: this.state.totalCost.value,
      costTypeId: cpId.costTypeId,
      costTypeName: cpId.costTypeName,
      allocationKeyId: cpId.allocationKeyId,
      allocationKeyName: cpId.allocationKeyName,
      consumptionDataAvailable: cpId.meterData,
      costTypeIdentifier: cpId.costTypeIdentifier,
      allcationKeyUnits: cpId.allcationKeyUnits,
      orderNo: cpId.orderNo,
      vatAmount: cpId.vatAmount,
      laborCost: cpId.laborCost
    };

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'costPositions/' + this.props.cpId.id,
      'PUT',
      payload,
      null,
      false,
      true,
      false,
      this,
      '_handleCostPositionSaving',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  _handleCostPositionSaving(response){
  }

  _handlePropertyPut=(response)=>{
    console.log('_handlePropertyPut: ', response);
    if(response.status){
      this.updateProperties(response.other.updatePropertyData)
    }
  }

  updateProperties(updated_property_response) {
    let {propertySelected} = this.props;
    propertySelected={
      ...propertySelected,
      heatingType: Autoload.MainHelper.checkProperty(updated_property_response, 'heatingType'),
      heatingTemperature: Autoload.MainHelper.checkProperty(updated_property_response, 'heatingTemperature'),
      heatingTemp: Autoload.MainHelper.checkProperty(updated_property_response, 'heatingTemperature'),
      consumptionValue: Autoload.MainHelper.checkProperty(updated_property_response, 'consumptionShare', 0),
      consumptionShare: Autoload.MainHelper.checkProperty(updated_property_response, 'consumptionShare', 0),
      energyFuelType: Autoload.MainHelper.checkProperty(updated_property_response, 'energyFuelType', null),
      centralWarmWaterAllocationKey: Autoload.MainHelper.checkProperty(updated_property_response, 'centralWarmwaterAllocationKey', null),
      heatedFloorSpace: Autoload.MainHelper.checkProperty(updated_property_response, 'heatedFloorSpace', null)
    }
    this.props.changeCurrentProperty(propertySelected);
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';
  }

  // [FIX] Update putHeatingCosts to take ID
  putHeatingCosts=(cpPutData, stopGetCall=false, runUpdateReceiptAssignmentId=null)=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCosts',//?utilityBillingId=' + this.props.currentDataId,
      'PUT',
      cpPutData,
      null,
      false,
      true,
      false,
      this,
      '_handleCpPut',
      {stopGetCall, runUpdateReceiptAssignmentId}, // [FIX] Pass ID in object
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  // [FIX] Handle the ID in response
  _handleCpPut = (response) => {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_save_heat_cost);
      loader(false);
    }

    if(response.other.stopGetCall === false){
      this.getHeatingCosts(false, true);
    }

    this.getCpOptions();

    // [FIX] If we have a specific ID, update only that one
    if(response.other.runUpdateReceiptAssignmentId){
      this.setState({runUpdateReceiptAssignmentsByCostPositionId: response.other.runUpdateReceiptAssignmentId}, ()=> {
          this.updateReceiptAssignmentsByCostPositionId(false); // [FIX] Explicitly pass false
      });
    }
  };

  _handleUtilityPut = (response) => {
    if (response.status) {
      showNotification({
        message: 'Die Änderungen wurden übernommen.',
        icon: <img src={GreenTick} alt='green-tick'/>,
        //style: {marginLeft: !this.props.isTablet && '24.5%', width: '100%'},
      });
      console.log('apis completed');
      this.props.toggle();
    }
    this.props.setRunUpdateHeatingCostSplit(true);
    this.state.openRedirectAlert ? this.props.history.push('/property/heatingCostInformation') : setTimeout(() => {
      this.props.callUpdate(response.status && response.statuscode === 200);
      this.props.updateCalculationStatus(true);
      //this.props.callGetDataApi();
      //window.open(window.location.href, '_self');
    }, 600); //this.updateCostSplit();
    loader(false);
  };
  manipulateReciept = () => {
    (this.state.receiptAdded.length > 0 || this.state.receiptDeleted.length > 0) && loader(true);

    if (this.state.receiptAdded.length > 0) {
      this.state.receiptAdded.forEach((receipt, i) => {
        let addedReceipt = {
          receiptId: checkProperty(receipt, 'id'),
          receiptName: checkProperty(receipt, 'receiptName'),
          // receiptDate: checkProperty(receipt, 'date'),
          proRataDays: 123,
          costPositionId: this.props.cpId,
          receiptAssignmentId: null,
        };

        Autoload.HttpRequestAxios.HttpRequest(
          Autoload.Setting.ub_api_base_url + 'receiptAssignments',
          'POST',
          addedReceipt,
          null,
          false,
          true,
          false,
          this,
          '_handlePostReceipts',
          null,
          false,
          '',
          {
            Authorization: Autoload.Utils.getAuthToken(),
          }
        );
      });
    }
    //api to delete receipts
    if (this.state.receiptDeleted.length > 0) {
      this.state.receiptDeleted.forEach((receipt) => {
        Autoload.HttpRequestAxios.HttpRequest(
          Autoload.Setting.ub_api_base_url + 'receiptAssignments/' + receipt.receiptAssignmentId,
          'DELETE',
          null,
          null,
          false,
          true,
          false,
          this,
          '_handleDeleteReceipts',
          null,
          false,
          '',
          {
            Authorization: Autoload.Utils.getAuthToken(),
          }
        );
      });
    }
  };
  _handlePostReceipts = (response) => {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, 'Error occured while saving receipt assignment!');
    }
    loader(false);
  };
  _handleDeleteReceipts = (response) => {
    if (response.status == false) {
      Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, 'Error occured while deleting receipt assignment!');
    }
    loader(false);
  };

  calculateTotalCO2Emissions=(value, option, isCO2TaxActivatedUpdate=null)=>{
    const {isCO2TaxActivated} = this.state;
    console.log('calculateTotalCO2Emissions: ', isCO2TaxActivatedUpdate || isCO2TaxActivated);
    return (isCO2TaxActivatedUpdate || isCO2TaxActivated) ? option.fuelTypeName === 'Heizleistung (kWh)' ? NaN : (value * option.conversionkWh) * option.conversionCO2EmissionskgBykWh : null;
  }

  energyChange = (option) => {
    const {amount, utilityBillingData} = this.state;
    let totalCO2Emissions = this.calculateTotalCO2Emissions(amount.value, option);
    console.log('energyChange: ', totalCO2Emissions, option.conversionkWh, option.conversionCO2EmissionskgBykWh, amount.value, (amount.value * option.conversionkWh) * option.conversionCO2EmissionskgBykWh);
    this.setState({
      selectedEnergy: {
        id: option.id,
        fuelTypeName: option.fuelTypeName,
        conversionkWh: option.conversionkWh,
        conversionCO2EmissionskgBykWh: option.conversionCO2EmissionskgBykWh,
      },
      selectedEnergyErr: false,
      totalCO2Emissions
    }, ()=> this.postCO2TaxReimbursementValue());
  };

  allocationChange = (option) => {
    this.setState({
      selectedAllocation: {
        id: option.id,
        allocationKeyName: option.allocationKeyName,
        conversionkWh: option.conversionkWh,
        units: option.units,
        propertyId: option.propertyId,
        metered: option.metered,
        systemAllocationKey: option.systemAllocationKey,
        type: option.type
      },
      selectedAllocationErr: false
    });
  };
  handleEnterKeyPress = (e) => {
    if (e.charCode == 13) {
      e.preventDefault();
      this.handleSubmit(e);
    }
  };
  resetForm = () => {
    this.setState(this.initialState);
  };

  toggleAddReceiptModal = (cp) => {
    if (cp !== undefined) {
      this.setState({currentCp: cp});
    }
    this.setState({ addReceiptOpen: !this.state.addReceiptOpen });
    //this.getAllByBillingPeriodCostType(this.billingPeriodId, this.costTypeId);
    this.props.callApis();
  };
  
  bind_list_receipt_data = () => {
    let propertyid = this.props.propertySelected && this.props.propertySelected.id;
    GlobalServices._getReceiptsByPropertyWithFilters(this, 'handle_get_list_data', {propertyId: propertyid, includeDetails: false});
    // Autoload.HttpRequestAxios.HttpRequest(
    //   Autoload.Setting.rm_api_base_url + 'search?' + `propertyId=${propertyid}` + `&includeDetails=false`,
    //   'GET',
    //   null,
    //   null,
    //   false,
    //   true,
    //   false,
    //   this,
    //   'handle_get_list_data',
    //   null,
    //   false,
    //   '',
    //   {
    //     'Content-Type': 'application/json',
    //     Authorization: Autoload.Utils.getAuthToken(),
    //   }
    // );
  };

  handle_get_list_data(response) {
    if (this.state.currentCp) {
      //this.onReceiptSelect({ id: response.result[0]?.id, name: response.result[0]?.name }, this.state.currentCp);
    }
  }

  toggleViewDetailsModal = (recordId) => {
    console.log('recordId: ', recordId);
    this.props.toggleViewDetailsModal(recordId)
  }

  saveHeatingCost=(heatingCost)=>{
    const {addHeatingCostModalCostPositionId, costPositions} = this.state;
    if(addHeatingCostModalCostPositionId && addHeatingCostModalCostPositionId !== 0){
      let cpPutData = costPositions.filter((i) => i.id !== 0)
      .map((cp) => {
        if(cp.id === addHeatingCostModalCostPositionId){
          return {
            id: cp.id,
            heatingCostType: heatingCost,
            heatingCostTypeName: heatingCost,
            // [FIX] Don't convert if it's already a number
            heatingCost: typeof cp.heatingCost === 'number' ? cp.heatingCost : Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost ? cp.heatingCost : 0),
            systemHeatingCostTypeId: null,
            displayOrder: cp.displayOrder,
            vatAmount: cp.vatAmount,
            laborCost: cp.laborCost
          }
        }else{
          return {
            id: cp.id,
            heatingCostType: cp.heatingCostType,
            heatingCostTypeName: cp.heatingCostType,
            // [FIX] Don't convert if it's already a number
            heatingCost: typeof cp.heatingCost === 'number' ? cp.heatingCost : Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost ? cp.heatingCost : 0),
            systemHeatingCostTypeId: cp.systemHeatingCostTypeId,
            displayOrder: cp.displayOrder,
            vatAmount: cp.vatAmount,
            laborCost: cp.laborCost
          }
        }
      });
      if (cpPutData.length) {
        this.putHeatingCosts(cpPutData);
      }
    }else{
      this.addHeatingCost(false, true, heatingCost);
    } 
  }

  handleHeatingCpPut(response){
    if(response.status && response.statuscode === 200){
      if(response.other.stopGetCall === false){
        this.getHeatingCosts();
      }
    }
  }

  postCO2TaxReimbursementValue = (callBackFunction=null) => {
    const {utilityBillingData, isCO2TaxActivated, amount, unitAmount, totalCost, totalCO2Emissions, isCO2TaxMainlyUsedForBusiness, isCO2TaxPreservationObject, propertyData, selectedEnergy} = this.state;
    
    if(isCO2TaxActivated){
      let payload = {
        ...utilityBillingData,
        heatingEnergyType: selectedEnergy,
        heatingEnergyAmount: amount?.value,
        energyAmountWarmWater: unitAmount?.value,
        totalHeatingCost: totalCost?.value,
        totalCO2Emissions: totalCO2Emissions,
        isCO2TaxMainlyUsedForBusiness,
        isCO2TaxPreservationObject,
        isCO2TaxActivated,
        property: propertyData
      }
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'CO2TaxReimbursementValue',
        'POST',
        payload,
        null,
        false,
        true,
        false,
        this,
        '_handleGetCO2TaxReimbursementValue',
        {callBackFunction},
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }
  };

  _handleGetCO2TaxReimbursementValue(response){
    if(response.status && response.statuscode === 200){
      //console.log('_handleGetCO2TaxReimbursementValue: ', response);
      let {costPositions, co2TaxReturnLandlordShareSystemId} = this.state;
      costPositions = costPositions.map((cp)=> {
        if(cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId){
          cp.heatingCost = response.result.cO2TaxLandlordShare;
          cp.vatAmount = response.result.cO2TaxVATShareLandloard;
        }
        return cp;
      });
      console.log('_handleGetCO2TaxReimbursementValue: ', costPositions);
      this.setState({costPositions}, ()=> this.calculateTotalOnAmountChange());
    }

    if(typeof response.other.callBackFunction === 'function'){
      response.other.callBackFunction();
    }
  }

  createEmptyHeatingCostPosition=()=>{
    const {cpOptions, costPositions} = this.state;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCosts',//?utilityBillingId=' + this.props.currentDataId,
      'POST',
      { 
        heatingCostType: null,//cpOptions[0].heatingCostTypeName, 
        heatingCostTypeName: null,//cpOptions[0].heatingCostTypeName, 
        heatingCost: 0, 
        systemHeatingCostTypeId: null,//cpOptions[0].id ? cpOptions[0].id : null,
        displayOrder: costPositions.length > 0 ? 
        (costPositions.length === 1 ? 
          (costPositions[0].displayOrder === 99 ? 1 : (costPositions[0].displayOrder + 1)) : 
          (costPositions[costPositions.length - 2].displayOrder + 1)) 
        : 1,
        utilityBillingId: this.props.currentDataId,
        propertyId: this.props.propertySelected?.id
      },
      null,
      false,
      true,
      false,
      this,
      'handleCreateEmptyHeatingCostPosition',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleCreateEmptyHeatingCostPosition(response){
    if(response.statuscode === 200 && response.status){
      this.getHeatingCosts();
    }
    this.setState({addHeatingCostPositionLoader: false});
  }
  
  saveNewVatAmountAndLaborCost=(vatAmount, laborCost)=> {
    const {costPositions, selectedHCPforVATlabourEdit} = this.state;
    let newCostPositions = costPositions;
    newCostPositions = newCostPositions.map((cp)=> {
      if(cp.id === selectedHCPforVATlabourEdit.id){
        cp.vatAmount = vatAmount;
        cp.laborCost = laborCost;
      }
      return cp;
    });
    this.setState({costPositions: newCostPositions, openEditVatAndLabourAmount: false, selectedHCPforVATlabourEdit: null, newVatAmount: null, newLaborCost: null}, ()=> {
      let cpPutData = newCostPositions
      .filter((i) => i.id !== 0)
      .map((cp) => ({
        id: cp.id,
        heatingCostType: cp.heatingCostType,
        // [FIX] Don't convert if it's already a number
        heatingCost: typeof cp.heatingCost === 'number' ? cp.heatingCost : Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost ? cp.heatingCost : 0),
        systemHeatingCostTypeId: cp.systemHeatingCostTypeId,
        heatingCostTypeName: cp.heatingCostType,
        displayOrder: cp.displayOrder,
        vatAmount: cp.vatAmount,
        laborCost: cp.laborCost
      }));
      if (cpPutData.length) {
        if(selectedHCPforVATlabourEdit){
          this.setState(prevState => ({ loadingRowIds: [...prevState.loadingRowIds, selectedHCPforVATlabourEdit.id] }));
        }
        this.putHeatingCosts(cpPutData);
      }
    });
  }

  updateReceipt=(selectedItem=null, utilityBillingRelevant=null, costPositionDeletionProcess=false)=>{
    //this.props.skeletonLoadingTrue();
    this.setState({skeletonLoading: true});
    const {removedItems, newAmount} = this.state;
    console.log('removedItems: ', removedItems);
    let data=null;
    if(selectedItem){
      data=[{
        //...selectedItem,
        id: selectedItem.id,
        utilityBillingRelevant: utilityBillingRelevant ? utilityBillingRelevant : !selectedItem.utilityBillingRelevant,
        //receiptDate: selectedItem.receiptDate.includes('T') ? selectedItem.receiptDate : `${dayjs(selectedItem.receiptDate, 'DD.MM.YYYY').format('YYYY-MM-DD')}T00:00:00`
      }];
      this.putReceipts(data, true);
    }else{
      data = removedItems.map((item, index)=> {
        return {
          //...item,
          id: item.id,
          utilityBillingRelevant: false,
          //receiptDate: item.receiptDate.includes('T') ? item.receiptDate : `${dayjs(item.receiptDate, 'DD.MM.YYYY').format('YYYY-MM-DD')}T00:00:00`
        }
      });
      this.putReceipts(data, true, costPositionDeletionProcess);
    }
  }

  putReceipts=(receipts, eol=false, costPositionDeletionProcess=false)=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.rm_api_base_url + 'receipt/UpdateUtilityBillingRelevant',//+ receipt.id,
      'PUT',
      receipts,
      null,
      false,
      true,
      false,
      this,
      'handleUpdateReceipt',
      {costPositionDeletionProcess},//{receiptId: receipt.id, eol},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleUpdateReceipt(response){
    const {selectedHeatingCostPositionForDeletionId} = this.state;
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_remove_receipt);
    }
    //this.removeAmount(this.state.removedItems.find((item)=> item.id === response.other.receiptId));
    // if(newAmount){
    //   this.updateReceiptAssignmentsByCostPositionId();
    // }else{
    //   this.props.updateReceiptAssignments();
    //   this.setState({skeletonLoading: false});
    // }
    //this.props.callApis();
    // if(response.other.eol){
      if(response.other.costPositionDeletionProcess){
        this.deleteHeatingCost(selectedHeatingCostPositionForDeletionId);
      }
      this.updateReceiptAssignmentsByCostPositionId();
      this.setState({removedItems: null, openRemoveReceiptAssignmentModal: false, openRemoveReceiptAssignmentForCpAmountModal: false, openEditVatAndLabourAmount: false});
    // }
    // this.getSelectedReceipts();
    // this.props.skeletonLoadingFalse();
  }

  checkIsNotEmpty=(value)=>{
    return (value !== undefined && value !== null);
  }

  updateReceiptAssignmentsByCostPositionId = (runForAllHeatingTypes=false) => {
    const {selectedHCPforVATlabourEdit, selectedHCPforAmountEdit, newAmount, newLaborCost, newVatAmount, runUpdateReceiptAssignmentsByCostPositionId} = this.state;
    if(this.props.propertySelected && this.props.propertySelected.propertyType === 'REGULAR' && (this.checkIsNotEmpty(newVatAmount) || this.checkIsNotEmpty(newLaborCost) || this.checkIsNotEmpty(newAmount) || runUpdateReceiptAssignmentsByCostPositionId || runForAllHeatingTypes)){
      let heatingCostId= (this.checkIsNotEmpty(newVatAmount) || this.checkIsNotEmpty(newLaborCost)) ? selectedHCPforVATlabourEdit?.id : this.checkIsNotEmpty(newAmount) ? selectedHCPforAmountEdit?.id : runUpdateReceiptAssignmentsByCostPositionId;
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'updateReceiptAssignmentsAndCostPositions?utilityBillingId=' + this.props.currentDataId+ '&costPositionId='+this.props.cpId.id+ (runForAllHeatingTypes ? '&isNonHeatingType=false' : '&heatingCostId='+heatingCostId),
        'PUT',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleUpdateReceiptAssignmentsByCostPositionIdResponse',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }else{
      this.props.callApis();
      this.setState({receiptsLoader: false});
    }
  };

  handleUpdateReceiptAssignmentsByCostPositionIdResponse(response){
    const {newAmount, newLaborCost, newVatAmount, selectedHCPforAmountEdit, runUpdateReceiptAssignmentsByCostPositionId} = this.state;
    this.props.callApis();
    // if(newAmount){
    //   selectedHCPforVATlabourEdit.amount = newAmount
    //   this.setState({dataValues}, ()=> this.onAmountBlur('amount', newAmount, true));
    // }else if(newLaborCost || newVatAmount){
    //   this.setState({dataValues: {...this.state.dataValues, vatAmount: newVatAmount, laborCost: newLaborCost}}, ()=> {
    //     this.updateStore();
    //     this.updateRow();
    //     this.setState({openEditVatAndLabourAmount: false});
    //   });
    // }else{
    //   this.props.getCostPositionById();
    // }
    if(newVatAmount || newLaborCost){
      this.saveNewVatAmountAndLaborCost(newVatAmount, newLaborCost);  
    }else if(newAmount){
      this.onAmountBlur(
        'heatingCost',
        selectedHCPforAmountEdit.id,
        newAmount
      );
    }
     
    setTimeout(() => {
      this.getHeatingCosts();
      this.getSelectedReceipts(runUpdateReceiptAssignmentsByCostPositionId);
      this.setState({runUpdateReceiptAssignmentsByCostPositionId: null});
    }, 1000);
  }

  removalOfCO2TaxReimbursementCostPosition=()=>{
    const {co2TaxReturnLandlordShareSystemId} = this.state;
    let {costPositions} = this.state;
    costPositions = costPositions.map((cp)=> {
      if(cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId){
        cp.heatingCost = 0;
        cp.vatAmount = null;
      }
      return cp;
    });

    this.calculateTotalOnAmountChange();
    let cpPutData = costPositions
    .filter((i) => i.id !== 0)
    .map((cp) => ({
      id: cp.id,
      heatingCostType: cp.heatingCostType,
      heatingCost: cp.heatingCost,
      systemHeatingCostTypeId: cp.systemHeatingCostTypeId,
      heatingCostTypeName: cp.heatingCostType,
      displayOrder: cp.displayOrder,
      vatAmount: cp.vatAmount,
      laborCost: cp.laborCost
    }));
    if (cpPutData.length) {
      this.putHeatingCosts(cpPutData);
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { isCO2TaxActivated, co2TaxReturnLandlordShareSystemId, costPositions } = this.state;

    // 1. Get the exact visible list that was sorted in the UI
    let visiblePositions = costPositions
      .filter((cp) => isCO2TaxActivated === false ? cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId : true)
      .sort((a, b) => a.displayOrder - b.displayOrder);

    // 2. Move the item to its new position
    let newSortedVisible = arrayMoveImmutable(visiblePositions, oldIndex, newIndex);

    // 3. Re-assign displayOrder sequentially
    newSortedVisible = newSortedVisible.map((cp, index) => {
      if (cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId) {
        cp.displayOrder = 99; // Preserve fixed order for CO2 tax
      } else {
        cp.displayOrder = index + 1; // 1-based index
      }
      return cp;
    });

    // 4. Merge back any positions that were hidden (e.g., CO2 tax when disabled)
    let hiddenPositions = costPositions.filter((cp) =>
      isCO2TaxActivated === false && cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId
    );

    const updatedCostPositions = [...newSortedVisible, ...hiddenPositions];

    // 5. Update state and trigger the API call
    this.setState({ costPositions: updatedCostPositions }, () => {
      this.updateAllHeatingCostPositionsOrder();
    });
  };

  updateAllHeatingCostPositionsOrder = () => {
    let cpPutData = this.state.costPositions
      .filter((i) => i.id !== 0) // Exclude the empty creation row
      .map((cp) => ({
        id: cp.id,
        heatingCostType: cp.heatingCostType,
        heatingCost: typeof cp.heatingCost === 'number' ? cp.heatingCost : Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost ? cp.heatingCost : 0),
        systemHeatingCostTypeId: cp.systemHeatingCostTypeId,
        heatingCostTypeName: cp.heatingCostType,
        displayOrder: cp.displayOrder,
        vatAmount: cp.vatAmount,
        laborCost: cp.laborCost
      }));

    if (cpPutData.length > 0) {
      this.setState({ heatingCostsLoader: true });
      this.putHeatingCosts(cpPutData, true); // true = stopGetCall to prevent UI flickering
    }
  };

  render() {
    const { open, toggle, className, cpId, propertySelected, utilityData } = this.props;
    const { totalCost, amount, addReceiptOpen, unitAmount, openAlert, openDataFehlen, selectedAllocation, selectedAllocationErr, selectedEnergyErr, selectedEnergy, openRedirectAlert, totalCostInFocus, energyConsumptionInFocus, waterHeatConsumptionInFocus, totalCO2Emissions, isCO2TaxActivated, addHeatingCostModalOpen, billingPeriod, isCO2TaxMainlyUsedForBusiness, isCO2TaxPreservationObject, co2TaxReturnLandlordShareSystemId, costPositions, dropdownStateOne, heatingCostsLoader, openEditVatAndLabourAmount, selectedHCPforVATlabourEdit, currentCp, addHeatingCostPositionLoader, openRemoveReceiptAssignmentForCpAmountModal, openRemoveReceiptAssignmentModal, previousAmount, previousLaborCost, previousVatAmount, selectedHCPforAmountEdit, selectReceiptsForReceiptAssigmentModalOpen, selectedReceiptsForReceiptAssignments, selectedHeatingCostForReceiptAssignments, receiptsLoader, resetValuesToDefault, openRemoveReceiptAssignmentForCpDeleteModal, selectedHeatingCostPositionForDeletionId, selectedHeatingCostPositionAssignedReceiptsForDeletion, co2EmissionErr, loadingRowIds, cpOptions } = this.state;

    console.log('cpOptions: ', cpOptions);
    
    
    const renderSkeletonRow = (key) => (
      <TableRow key={key}>
        <TableCell width={'5%'}><Skeleton height={20} width={20} /></TableCell>
        <TableCell className='pl-0' width={'33%'}>
          <Skeleton height={38} radius="sm" />
        </TableCell>
        <TableCell width={'30%'}>
           <Group wrap="nowrap" justify='center' align={'center'} gap={10}>
             <Skeleton height={38} width="100%" radius="sm" />
             <Group wrap="nowrap" gap={10}>
                <Skeleton height={14} width={30} radius="xs" />
                <Skeleton height={14} width={30} radius="xs" />
             </Group>
           </Group>
        </TableCell>
        <TableCell>
          <Skeleton height={38} radius="sm" />
        </TableCell>
        <TableCell className='pr-0'>
           <Skeleton height={20} width={20} radius="xl" />
        </TableCell>
      </TableRow>
    );

    const renderAddCostPositionRow=()=>{
      return (
        <TableRow>
          <TableCell className='pl-0' style={{paddingRight: '10px', opacity: utilityData?.isSecured ? 0.8 : 1}} colSpan={4}>
              <Group gap={2} justify='center' onClick={() => {
                if(utilityData.isSecured === false && addHeatingCostPositionLoader === false){
                  this.setState({addHeatingCostPositionLoader: true}, ()=> this.createEmptyHeatingCostPosition());
                }
              }} className='empty-table-cell' style={{cursor: utilityData?.isSecured ? 'not-allowed' : 'pointer'}}>
                {addHeatingCostPositionLoader ?
                <Loader size={14}/>
                :
                <AddIcon className='add-heating-cost-position-icon'/>}
                <span>Kostenposition ergänzen</span>
              </Group>
          </TableCell>
          <TableCell width={'2.5%'} />
        </TableRow>
      );
    }
    return (
      <>
      {addReceiptOpen && (
        <ReceiptDetailModal
          history={this.props.history}
          record={null}
          parent={this}
          onCreateReceiptSelect={(id)=> this.getAllByBillingPeriodHeatingCostType(this.billingPeriodId, this.state.cpOptions, ()=> this.onCreateReceiptSelect(id, currentCp.id))}
          className="add-edit-receipt-modal"
          edit={false}
          open={addReceiptOpen}
          toggle={(id) => this.toggleAddReceiptModal(undefined)}
          utilityData={this.props.utilityData}
          timeFrame={this.props.timeFrame}
          billingRelevant
          selectedCostType={[{id: cpId.costTypeId}]}
          heatingCostType={cpId.costTypeIdentifier === 'HEATING_TOTAL' ? currentCp?.heatingCostType : null}
          cp={currentCp}
        />
      )}
      {openAlert &&
      <AlertModal
        heading={lang.utility.text_confirm_alert}
        open={openAlert}
        onCancel={()=> this.setState({checkboxone: false, openAlert: false})}
        cancel
        rightButtonText={'Bestätigen'}
        text={<span 
          style={{
            fontSize: '14px',
            lineHeight: '24px',
            color: 'rgb(14, 14, 29)',
            fontWeight: '400',
            fontFamily: 'Inter, sans-serif',
          }}>Wenn kein Verbrauch verfügbar ist, wird die Wärmmenge für Warmwasser automatisch abgeschätzt. Dies ist nur in Ausnahmefällen zulässig <a href="https://hilfe.hellohousing.de/de/articles/6779156-warum-muss-der-warmeverbrauch-fur-die-zentrale-warmwasserhitzung-separat-erfasst-werden" target="_blank">(mehr erfahren)</a>.</span>} 
        onClick={(e) => this.setState({checkboxone: true, openAlert: false})}
        toggle={() => {
          this.setState({checkboxone: false, openAlert: false})
        }}
      />}
    {openRedirectAlert &&
    <AlertModal
        heading={'Werte speichern'}
        open={openRedirectAlert}
        onCancel={()=> this.setState({openRedirectAlert: false})}
        cancel
        text={'Sollen die aktuellen Änderungen gespeichert werden?'} 
        onClick={(e) => {
          this.handleSubmit(e);
        }}
        toggle={() => {
          this.setState({openRedirectAlert: false});
        }}
        middle
        onMiddle={()=>{
          this.setState({openRedirectAlert: false});
          this.props.history.push('/property/heatingCostInformation');
        }}
        middleText={'Nein, weiter'}
        rightButtonText={'Ja, weiter'}
        />}
    {openDataFehlen &&
      <AlertModal
        heading={'Daten fehlen'}
        open={openDataFehlen}
        rightButtonText={'Speichern'}
        leftButtonText={'Zurück'}
        cancel
        text={propertySelected.heatingType === 'central with warm water' ? 'Zur Verteilung der Heizkosten sind die Angabe der Heizkosten, des Energieverbrauch und der Wärmemenge Warmwasser notwendig. Wollen Sie dennoch fortfahren?' 
        : 'Zur Verteilung der Heizkosten sind die Angabe der Heizkosten und des Energieverbrauch notwendig. Wollen Sie dennoch fortfahren?'} 
        onClick={(e) => {
          this.saveData(e);
          this.setState({openDataFehlen: false});
        }}
        toggle={() => {
          this.setState({openDataFehlen: false});
        }}
        onCancel={() => this.setState({openDataFehlen: false})}
      />
    }
      <CustomModal
        heading={lang.utility.text_calculate_heating_cost}
        headingClassName={'ub-heating-cost-modal-heading'}
        open={open}
        toggle={() => {
          this.resetForm();
          toggle();
        }}
        className={className}
        style={{minWidth: '800px'}}
      >
        <div style={{marginBottom: '20px'}}>
          <span style={{fontWeight: '400'}}>{`Geben Sie die Heizkosten und den Energieverbrauch der Abrechnungsperiode (${utilityData && utilityData.date}) an.`}</span>
        </div>
        <Form onSubmit={this.handleSubmit} ref={(ref) => { this.form = ref; }} noValidate>
          {/*this.saveData*/}
          <p className="heating-cost-text ub-heating-cost-modal-heating-costs mb-0">{lang.utility.text_Heating_costs}</p>
          <TableContainer>
            <Table className='heating-cost-positions-table'>
              <TableHead>
                <TableRow>
                  <TableCell style={{padding: '16px 8px 0px'}} width={'5%'} /> {/* Drag Handler Header */}
                  <TableCell style={{padding: '16px 8px 0px'}} className="cp-cost-position-label pl-0">{lang.newKeys.text_cost_positions}</TableCell>
                  <TableCell style={{padding: '16px 8px 0px'}} className="cp-cost-position-label">{lang.general.text_amount}</TableCell>
                  <TableCell style={{padding: '16px 8px 0px'}} className="cp-cost-position-label">{lang.receipt.text_receipts}</TableCell>
                  <TableCell style={{padding: '16px 8px 0px'}} className="pr-0"/>
                </TableRow>
              </TableHead>
              <SortableTableBody useDragHandle onSortEnd={this.onSortEnd} helperContainer={() => document.body}>
              {heatingCostsLoader && this.state.costPositions.length === 0 ? (
                <>
                  {renderSkeletonRow(1)}
                  {renderSkeletonRow(2)}
                  {renderSkeletonRow(3)}
                </>
              ) : (
                this.state.costPositions.filter((cp)=> isCO2TaxActivated === false ? cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId : cp)
                .sort((a,b)=> a.displayOrder - b.displayOrder).map((cp, i) => {
                  const isReceiptsLoading = !cp.receiptsLoaded || 
                  this.state.runUpdateReceiptAssignmentsByCostPositionId === cp.id || 
                  (this.state.receiptsLoader && this.state.currentCp?.id === cp.id);
                  if (loadingRowIds.includes(cp.id)) {
                    return renderSkeletonRow(cp.id);
                  }

                  const isCo2TaxRow = cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId;

                  return (
                <React.Fragment key={`fragment-${cp.id}`}>
                  {isCO2TaxActivated && 
                  this.state.costPositions.some(cp => cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId) &&
                  this.state.costPositions.filter((cp)=> isCO2TaxActivated === false ? cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId : cp).length === (i+1) && 
                  renderAddCostPositionRow()}
                  
                  <SortableTableRow
                    key={`item-${cp.id}`}
                    index={i}
                    disabled={utilityData?.isSecured || isCo2TaxRow}
                    content={
                      <TableRow>
                        <TableCell className='drag-handler-heating-costs-table-cell' style={{cursor: utilityData?.isSecured || isCo2TaxRow ? 'not-allowed' : 'pointer'}} width={'5%'}>
                          <div style={{ display: utilityData?.isSecured || isCo2TaxRow ? 'none' : 'block' }}>
                            <DragHandle />
                          </div>
                        </TableCell>
                        <TableCell className='pl-0' width={'33%'}>
                          <Form.Group style={{marginBottom: '0px', maxWidth: '240px'}}>
                            {cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId ?
                            <TooltipMaterialUI title='CO2-Steuer Erstattung Vermieteranteil wird durch hellohousing ermittelt.'>
                              <UncontrolledDropdown
                                id="keyid"
                                onBlur={() => {
                                  this.setState({
                                    dropdownStateOne: null
                                  });
                                }}
                                onClick={()=>{
                                  this.setState({
                                    dropdownStateOne: dropdownStateOne === cp.id ? null : cp.id
                                  });
                                }}
                              >
                                <DropdownToggle style={{minWidth: '200px'}} className="dropdown-select form-control" disabled={cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId}>
                                  <span className="cp_costtypename">{cp.heatingCostType}</span>
                                  <span>
                                    {' '}
                                    {this.state.dropdownStateOne !== cp.id ? (
                                      <img src={downArrow} alt="" />
                                    ) : (
                                      <img src={uparrow} alt="" />
                                    )}
                                  </span>
                                </DropdownToggle>
                                <DropdownMenu className="cp-menu">
                                  {this.state.cpOptions.sort((a,b)=> a.heatingCostTypeName.toLowerCase().localeCompare(b.heatingCostTypeName.toLowerCase()))
                                  .filter((option)=> option.id !== co2TaxReturnLandlordShareSystemId)
                                  .map((option, i) => (
                                    <DropdownItem
                                      key={i}
                                      onClick={() => {
                                        this.onCpChange('heatingCostType', cp.id, option);
                                      }}
                                      className="cpRow-options"
                                    >
                                      <span style={{ fontSize: 12 }}>{option.heatingCostTypeName}</span>
                                    </DropdownItem>
                                  ))}
                                  <DropdownItem
                                      key={this.state.cpOptions.length}
                                      onClick={() => {
                                        this.setState({addHeatingCostModalOpen: true, addHeatingCostModalCostPositionId: cp.id});
                                      }}
                                      className="cpRow-options"
                                    >
                                      <Group>
                                        <ColorButton
                                        text={'Kostenart hinzufügen'}
                                        className={'gray-btn'}
                                        onClick={() => null}
                                        />
                                      </Group>
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </TooltipMaterialUI>
                            :
                            <UncontrolledDropdown
                                id="keyid"
                                onBlur={() => {
                                  this.setState({
                                    dropdownStateOne: null
                                  });
                                }}
                                onClick={()=>{
                                  this.setState({
                                    dropdownStateOne: dropdownStateOne === cp.id ? null : cp.id
                                  });
                                }}
                              >
                                <DropdownToggle className={`dropdown-select form-control ${utilityData?.isSecured && 'disabled'}`} disabled={cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId || utilityData?.isSecured}>
                                  <span className="cp_costtypename" style={{color: !cp.heatingCostType && '#6c757d'}}> {cp.heatingCostType ? cp.heatingCostType : 'Wählen'}</span>
                                  <span>
                                    {' '}
                                    {this.state.dropdownStateOne !== cp.id ? (
                                      <img src={downArrow} alt="" />
                                    ) : (
                                      <img src={uparrow} alt="" />
                                    )}
                                  </span>
                                </DropdownToggle>
                                <DropdownMenu className="cp-menu">
                                  {this.state.cpOptions.filter((option)=> option.id !== co2TaxReturnLandlordShareSystemId)
                                  .filter((option)=> this.state.costPositions.find((costPosition)=> costPosition.heatingCostType === option.heatingCostTypeName) === undefined)
                                  .map((option, i) => (
                                    <DropdownItem
                                      key={i}
                                      onClick={() => {
                                        this.onCpChange('heatingCostType', cp.id, option);
                                      }}
                                      className="cpRow-options"
                                    >
                                      <span style={{ fontSize: 12 }}>{option.heatingCostTypeName}</span>
                                    </DropdownItem>
                                  ))}
                                  <DropdownItem
                                      key={this.state.cpOptions.length}
                                      onClick={() => {
                                        this.setState({addHeatingCostModalOpen: true, addHeatingCostModalCostPositionId: cp.id});
                                      }}
                                      className="cpRow-options"
                                      style={{padding: 0}}
                                    >
                                      <Group>
                                        <ColorButton
                                        text={'Kostenart hinzufügen'}
                                        className={'gray-btn'}
                                        onClick={() => null}
                                        />
                                      </Group>
                                  </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>}
                          </Form.Group>
                        </TableCell>
                        <TableCell width={'30%'}>
                          <Group wrap="nowrap" justify='center' align={'center'} gap={10}>
                            <TooltipMaterialUI 
                            disableFocusListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                            disableHoverListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                            disableTouchListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId}
                            title='CO2-Steuer Erstattung Vermieteranteil wird durch hellohousing ermittelt.'>
                              <Group>
                                <NumericFormat 
                                className={`form-control ${utilityData?.isSecured && 'disabled'}`}
                                value={cp.heatingCostType && cp.heatingCost}
                                thousandSeparator="." 
                                decimalSeparator=","
                                onValueChange={(values, sourceInfo) => {
                                  this.onCpChange(
                                    'heatingCost',
                                    cp.id,
                                    values.floatValue,
                                    false
                                  )
                                }}
                                onKeyPress={this.handleEnterKeyPress}
                                placeholder={!cp.heatingCostType ? '' : '0,00 €'}
                                suffix=' €'
                                onBlur={(e) => {
                                  if (!e.target.value && cp.heatingCost) {
                                  } else {
                                    if(this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))).length > 0){
                                      this.setState({
                                        openRemoveReceiptAssignmentForCpAmountModal: true, 
                                        selectedHCPforAmountEdit: cp,
                                        removedItems: this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))),
                                        newAmount: cp.heatingCost
                                      });
                                    }else{
                                      this.onAmountBlur(
                                        'heatingCost',
                                        cp.id,
                                        cp.heatingCost
                                      );
                                    }
                                  }
                                }}
                                onFocus={()=> this.setState({previousAmount: cp.heatingCost})}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                allowNegative={true}
                                style={{cursor: !cp.heatingCostType && 'not-allowed', maxWidth: cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId && '110.75px', textAlign: 'right', minHeight: '36px'}}
                                disabled={!cp.heatingCostType || cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId || utilityData?.isSecured}
                                />
                              </Group>
                            </TooltipMaterialUI>
                            <TooltipMaterialUI 
                            disableFocusListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                            disableHoverListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                            disableTouchListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId}
                            title='CO2-Steuer Erstattung Vermieteranteil wird durch hellohousing ermittelt.'>
                              <Group wrap="nowrap" gap={10}>
                                <div style={{opacity: !cp.heatingCostType && '0.7', cursor: !cp.heatingCostType && 'not-allowed'}} className={cp.vatAmount ? 'sub-text-ub-costposition-amount' : 'sub-text-ub-costposition-amount-disabled'} onClick={()=> cp.heatingCostType && this.setState({openEditVatAndLabourAmount: true, selectedHCPforVATlabourEdit: cp, previousVatAmount: cp.vatAmount, previousLaborCost: cp.laborCost})}>
                                  Mwst
                                </div>
                                <div style={{opacity: !cp.heatingCostType && '0.7', cursor: !cp.heatingCostType && 'not-allowed', visibility: cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId && 'hidden'}} className={cp.laborCost ? 'sub-text-ub-costposition-amount' : 'sub-text-ub-costposition-amount-disabled'} onClick={()=> cp.heatingCostType && this.setState({openEditVatAndLabourAmount: true, selectedHCPforVATlabourEdit: cp, previousVatAmount: cp.vatAmount, previousLaborCost: cp.laborCost})}>
                                  Lohn
                                </div>
                              </Group>
                            </TooltipMaterialUI>
                          </Group>
                        </TableCell>
                        <TableCell>
                          <div style={{fontSize: '14px', maxWidth: '240px'}}>
                            {cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId &&
                            <MultiselectDropdown
                              className="cost-allocation-receipts"
                              tableView={true}
                              newTable={true}
                              viewDetails={true}
                              displayValue2="receiptDate"
                              placeholder={(utilityData.isSecured || !cp.heatingCostType) ? '' : lang.newKeys.text_select}
                              showScrollBarForDropDown={true}
                              options={this.state.receipts.filter((receipt)=> receipt.heatingCostType === cp.heatingCostType)}
                              selectedValues={cp.assignedReceipts.length > 0 ? this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))) : []}
                              onSelect={(selectedList, selectedItem)=> this.onReceiptSelect(selectedList, selectedItem, cp.id)} 
                              onRemove={(selectedList, removedItem)=> this.onReceiptRemove(selectedList, cp.assignedReceipts.find((assignedReceipt)=> assignedReceipt.receiptId === removedItem.id), cp.id)}
                              displayValue="name"
                              toggleViewDetailsModal={this.toggleViewDetailsModal}
                              receiptAssignment={true}
                              loadingReceiptAssignments={isReceiptsLoading}
                              disable={utilityData.isSecured || !cp.heatingCostType}
                              multiSelect
                              endListContent={
                                <div
                                className="gray-btn utitlity-add-cost-button"
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: 40,
                                  cursor: 'pointer',
                                  border: '1px solid #eee  ',
                                }}
                                onClick={() => this.toggleAddReceiptModal(cp)}
                              >
                                {'Neuer Beleg'}
                              </div>
                              }
                              onClickForEmpty={()=> this.setState({selectReceiptsForReceiptAssigmentModalOpen: true, 
                              selectedReceiptsForReceiptAssignments: this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))),
                              selectedHeatingCostForReceiptAssignments: cp.heatingCostType, runUpdateReceiptAssignmentsByCostPositionId: cp.id,
                              currentCp: cp})}
                              launchIconOnClick={()=> this.setState({selectReceiptsForReceiptAssigmentModalOpen: true, selectedReceiptsForReceiptAssignments: this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))),
                              selectedHeatingCostForReceiptAssignments: cp.heatingCostType,
                              runUpdateReceiptAssignmentsByCostPositionId: cp.id,
                              currentCp: cp})}
                            />}
                          </div>
                        </TableCell>
                        <TableCell className='pr-0'>
                          {cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId &&
                          <button disabled={utilityData.isSecured} style={{ cursor: utilityData.isSecured ? 'not-allowed' : 'pointer' }} 
                          onClick={() => {
                            if(utilityData.isSecured === false){
                              if(cp.assignedReceipts.length > 0){
                                const assignedReceiptsForDeletion = cp.assignedReceipts.map((receiptAssignment)=> ({id: receiptAssignment.receiptId, utilityBillingRelevant: false}));
                                this.setState({openRemoveReceiptAssignmentForCpDeleteModal: true, selectedHeatingCostPositionForDeletionId: cp.id, selectedHeatingCostPositionAssignedReceiptsForDeletion: assignedReceiptsForDeletion});
                              }else{
                                this.deleteHeatingCost(cp.id);
                              }
                            }
                          }} 
                          type="button" class={`close ${utilityData?.isSecured ? 'delete-cost-position-disabled' : 'delete-cost-position'}`} aria-label="Close"><span aria-hidden="true">×</span></button>}
                        </TableCell>
                      </TableRow>
                    }
                  />
                </React.Fragment>
                )})
              )}
                {(this.state.costPositions.length === 0 || (!isCO2TaxActivated || !this.state.costPositions.some(cp => cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId))) && !heatingCostsLoader && renderAddCostPositionRow()}
                <TableRow>
                  <TableCell width={'5%'}/> {/* Filler for the drag column offset */}
                  <TableCell className='pl-0'>
                    <Group className='total-heating-cost-label' style={{marginTop: '1px'}} justify='right'>
                      <span style={{fontSize: '14px', color: 'rgb(14, 14, 29)', fontWeight: '400'}}>{lang.utility.text_total_costs}</span>
                    </Group>
                  </TableCell>
                  <TableCell>
                    <Group wrap="nowrap" gap={10} justify='center' align={'center'}>
                      <NumericFormat 
                      className={`form-control`}
                      value={totalCost.value}
                      thousandSeparator="." 
                      decimalSeparator=","
                      onValueChange={(values, sourceInfo) => {
                        this.onInputChange('totalCost', values.floatValue)
                      }}
                      onKeyPress={this.handleEnterKeyPress}
                      placeholder='0,00 €'
                      suffix=' €'
                      style={{textAlign: 'right'}}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={true}
                      disabled={true}
                      />
                      <Group wrap="nowrap" gap={10} style={{visibility: 'hidden'}}>
                        <div className={'sub-text-ub-costposition-amount-disabled'}>
                          Mwst
                        </div>
                        <div className={'sub-text-ub-costposition-amount-disabled'}>
                          Lohn
                        </div>
                      </Group>
                    </Group>
                  </TableCell>
                  <TableCell colSpan={2}/> {/* Padding for the right side */}
                </TableRow>
              </SortableTableBody>
            </Table>
          </TableContainer>
          {/* <TableContainer>
            <Table className='heating-cost-positions-table'>
              <TableHead>
                <TableRow>
                  <TableCell style={{padding: '16px 8px 0px'}} width={'5%'}/>
                  <TableCell style={{padding: '16px 8px 0px'}} className="cp-cost-position-label pl-0">{lang.newKeys.text_cost_positions}</TableCell>
                  <TableCell style={{padding: '16px 8px 0px'}} className="cp-cost-position-label">{lang.general.text_amount}</TableCell>
                  <TableCell style={{padding: '16px 8px 0px'}} className="cp-cost-position-label">{lang.receipt.text_receipts}</TableCell>
                  <TableCell style={{padding: '16px 8px 0px'}} className="pr-0"/>
                </TableRow>
              </TableHead>
              <SortableTableBody useDragHandle onSortEnd={this.onSortEnd} helperContainer={() => document.body}>
              {heatingCostsLoader && this.state.costPositions.length === 0 ? (
                <>
                  {renderSkeletonRow(1)}
                  {renderSkeletonRow(2)}
                  {renderSkeletonRow(3)}
                </>
              ) : (
                this.state.costPositions.filter((cp)=> isCO2TaxActivated === false ? cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId : cp)
                .sort((a,b)=> a.displayOrder - b.displayOrder).map((cp, i) => {
                  const isReceiptsLoading = !cp.receiptsLoaded || 
                  this.state.runUpdateReceiptAssignmentsByCostPositionId === cp.id || 
                  (this.state.receiptsLoader && this.state.currentCp?.id === cp.id);
                  if (loadingRowIds.includes(cp.id)) {
                    return renderSkeletonRow(cp.id);
                  }
                  return (
                <>
                  {isCO2TaxActivated && 
                  this.state.costPositions.some(cp => cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId) &&
                  this.state.costPositions.filter((cp)=> isCO2TaxActivated === false ? cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId : cp).length === (i+1) && 
                  renderAddCostPositionRow()}
                  <TableRow>
                    <TableCell className='pl-0' width={'33%'}>
                      <Form.Group style={{marginBottom: '0px', maxWidth: '240px'}}>
                        {cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId ?
                        <TooltipMaterialUI title='CO2-Steuer Erstattung Vermieteranteil wird durch hellohousing ermittelt.'>
                          <UncontrolledDropdown
                            id="keyid"
                            onBlur={() => {
                              this.setState({
                                dropdownStateOne: null
                              });
                            }}
                            onClick={()=>{
                              this.setState({
                                dropdownStateOne: dropdownStateOne === cp.id ? null : cp.id
                              });
                            }}
                          >
                            <DropdownToggle style={{minWidth: '200px'}} className="dropdown-select form-control" disabled={cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId}>
                              <span className="cp_costtypename">{cp.heatingCostType}</span>
                              <span>
                                {' '}
                                {this.state.dropdownStateOne !== cp.id ? (
                                  <img src={downArrow} alt="" />
                                ) : (
                                  <img src={uparrow} alt="" />
                                )}
                              </span>
                            </DropdownToggle>
                            <DropdownMenu className="cp-menu">
                              {this.state.cpOptions.sort((a,b)=> a.heatingCostTypeName.toLowerCase().localeCompare(b.heatingCostTypeName.toLowerCase()))
                              .filter((option)=> option.id !== co2TaxReturnLandlordShareSystemId)
                              .map((option, i) => (
                                <DropdownItem
                                  key={i}
                                  onClick={() => {
                                    this.onCpChange('heatingCostType', cp.id, option);
                                  }}
                                  className="cpRow-options"
                                >
                                  <span style={{ fontSize: 12 }}>{option.heatingCostTypeName}</span>
                                </DropdownItem>
                              ))}
                              <DropdownItem
                                  key={this.state.cpOptions.length}
                                  onClick={() => {
                                    this.setState({addHeatingCostModalOpen: true, addHeatingCostModalCostPositionId: cp.id});
                                    //this.onCpChange('heatingCostType', cp.id, option);
                                  }}
                                  className="cpRow-options"
                                >
                                  <Group>
                                    <ColorButton
                                    text={'Kostenart hinzufügen'}
                                    className={'gray-btn'}
                                    onClick={() => null}
                                    />
                                  </Group>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </TooltipMaterialUI>
                        :
                        <UncontrolledDropdown
                            id="keyid"
                            onBlur={() => {
                              this.setState({
                                dropdownStateOne: null
                              });
                            }}
                            onClick={()=>{
                              this.setState({
                                dropdownStateOne: dropdownStateOne === cp.id ? null : cp.id
                              });
                            }}
                          >
                            <DropdownToggle className={`dropdown-select form-control ${utilityData?.isSecured && 'disabled'}`} disabled={cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId || utilityData?.isSecured}>
                              <span className="cp_costtypename" style={{color: !cp.heatingCostType && '#6c757d'}}> {cp.heatingCostType ? cp.heatingCostType : 'Wählen'}</span>
                              <span>
                                {' '}
                                {this.state.dropdownStateOne !== cp.id ? (
                                  <img src={downArrow} alt="" />
                                ) : (
                                  <img src={uparrow} alt="" />
                                )}
                              </span>
                            </DropdownToggle>
                            <DropdownMenu className="cp-menu">
                              {this.state.cpOptions.filter((option)=> option.id !== co2TaxReturnLandlordShareSystemId)
                              .filter((option)=> this.state.costPositions.find((costPosition)=> costPosition.heatingCostType === option.heatingCostTypeName) === undefined)
                              .map((option, i) => (
                                <DropdownItem
                                  key={i}
                                  onClick={() => {
                                    this.onCpChange('heatingCostType', cp.id, option);
                                  }}
                                  className="cpRow-options"
                                >
                                  <span style={{ fontSize: 12 }}>{option.heatingCostTypeName}</span>
                                </DropdownItem>
                              ))}
                              <DropdownItem
                                  key={this.state.cpOptions.length}
                                  onClick={() => {
                                    this.setState({addHeatingCostModalOpen: true, addHeatingCostModalCostPositionId: cp.id});
                                    //this.onCpChange('heatingCostType', cp.id, option);
                                  }}
                                  className="cpRow-options"
                                  style={{padding: 0}}
                                >
                                  <Group>
                                    <ColorButton
                                    text={'Kostenart hinzufügen'}
                                    className={'gray-btn'}
                                    onClick={() => null}
                                    />
                                  </Group>
                              </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>}
                      </Form.Group>
                    </TableCell>
                    <TableCell width={'30%'}>
                      <Group wrap="nowrap" justify='center' align={'center'} gap={10}>
                        <TooltipMaterialUI 
                        disableFocusListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                        disableHoverListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                        disableTouchListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId}
                        title='CO2-Steuer Erstattung Vermieteranteil wird durch hellohousing ermittelt.'>
                          <Group>
                            <NumericFormat 
                            className={`form-control ${utilityData?.isSecured && 'disabled'}`}
                            value={cp.heatingCostType && cp.heatingCost}
                            thousandSeparator="." 
                            decimalSeparator=","
                            onValueChange={(values, sourceInfo) => {
                              this.onCpChange(
                                'heatingCost',
                                cp.id,
                                values.floatValue,
                                false
                              )
                            }}
                            onKeyPress={this.handleEnterKeyPress}
                            placeholder={!cp.heatingCostType ? '' : '0,00 €'}
                            suffix=' €'
                            onBlur={(e) => {
                              console.log('e.target.value: ', e.target.value, Autoload.MainHelper.convertCurrencyToNumber(e.target.value));
                              if (!e.target.value && cp.heatingCost) {
                                console.log(cp.heatingCost)
                                //e.target.value = Autoload.MainHelper.convertCurrencyToNumber(cp.heatingCost);
                              } else {
                                if(this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))).length > 0){
                                  this.setState({
                                    openRemoveReceiptAssignmentForCpAmountModal: true, 
                                    selectedHCPforAmountEdit: cp,
                                    removedItems: this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))),
                                    newAmount: cp.heatingCost//Autoload.MainHelper.convertCurrencyToNumber(e.target.value)
                                  });
                                }else{
                                  this.onAmountBlur(
                                    'heatingCost',
                                    cp.id,
                                    cp.heatingCost//Autoload.MainHelper.convertCurrencyToNumber(e.target.value)
                                  );
                                }
                                //e.target.value = Autoload.MainHelper.convertCurrencyToNumber(e.target.value);
                              }

                              
                            }}
                            onFocus={()=> this.setState({previousAmount: cp.heatingCost})}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={true}
                            style={{cursor: !cp.heatingCostType && 'not-allowed', maxWidth: cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId && '110.75px', textAlign: 'right', minHeight: '36px'}}
                            disabled={!cp.heatingCostType || cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId || utilityData?.isSecured}
                            />
                          </Group>
                        </TooltipMaterialUI>
                        <TooltipMaterialUI 
                        disableFocusListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                        disableHoverListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId} 
                        disableTouchListener={cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId}
                        title='CO2-Steuer Erstattung Vermieteranteil wird durch hellohousing ermittelt.'>
                          <Group wrap="nowrap" gap={10}>
                            <div style={{opacity: !cp.heatingCostType && '0.7', cursor: !cp.heatingCostType && 'not-allowed'}} className={cp.vatAmount ? 'sub-text-ub-costposition-amount' : 'sub-text-ub-costposition-amount-disabled'} onClick={()=> cp.heatingCostType && this.setState({openEditVatAndLabourAmount: true, selectedHCPforVATlabourEdit: cp, previousVatAmount: cp.vatAmount, previousLaborCost: cp.laborCost})}>
                              Mwst
                            </div>
                            <div style={{opacity: !cp.heatingCostType && '0.7', cursor: !cp.heatingCostType && 'not-allowed', visibility: cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId && 'hidden'}} className={cp.laborCost ? 'sub-text-ub-costposition-amount' : 'sub-text-ub-costposition-amount-disabled'} onClick={()=> cp.heatingCostType && this.setState({openEditVatAndLabourAmount: true, selectedHCPforVATlabourEdit: cp, previousVatAmount: cp.vatAmount, previousLaborCost: cp.laborCost})}>
                              Lohn
                            </div>
                          </Group>
                        </TooltipMaterialUI>
                      </Group>
                    </TableCell>
                    <TableCell>
                      <div style={{fontSize: '14px', maxWidth: '240px'}}>
                        {cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId &&
                        <MultiselectDropdown
                          className="cost-allocation-receipts"
                          tableView={true}
                          newTable={true}
                          viewDetails={true}
                          displayValue2="receiptDate"
                          placeholder={(utilityData.isSecured || !cp.heatingCostType) ? '' : lang.newKeys.text_select}
                          showScrollBarForDropDown={true}
                          // tableHeaders={[{ heading: 'receipt' }, { heading: 'date' }]}
                          // ref={this.multiselectRef}
                          options={this.state.receipts.filter((receipt)=> receipt.heatingCostType	=== cp.heatingCostType)}//.filter((receipt)=> receipt.heatingCostType	=== cp.heatingCostTypeName)} // Options to display in the dropdown
                          selectedValues={cp.assignedReceipts.length > 0 ? this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))) : []} // Preselected value to persist in dropdown
                          // options={this.props.receiptsArr} // Options to display in the dropdown
                          // selectedValues={this.props.cpId.selectedReceipt == null ? '' : this.props.cpId.selectedReceipt} // Preselected value to persist in dropdown
                          onSelect={(selectedList, selectedItem)=> this.onReceiptSelect(selectedList, selectedItem, cp.id)} // Function will trigger on select event
                          onRemove={(selectedList, removedItem)=> this.onReceiptRemove(selectedList, cp.assignedReceipts.find((assignedReceipt)=> assignedReceipt.receiptId === removedItem.id), cp.id)} // Function will trigger on remove event
                          displayValue="name"
                          toggleViewDetailsModal={this.toggleViewDetailsModal}
                          receiptAssignment={true}
                          loadingReceiptAssignments={isReceiptsLoading}
                          // placeholder="Select"
                          // closeIcon="cancel"
                          // avoidHighlightFirstOption={true}
                          // showCheckbox={true}
                          // disable={this.state.multiselectEnable}
                          // closeOnSelect={false}
                          // hidePlaceholder={true}
                          disable={utilityData.isSecured || !cp.heatingCostType}
                          multiSelect
                          endListContent={
                            <div
                            className="gray-btn utitlity-add-cost-button"
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: 40,
                              cursor: 'pointer',
                              border: '1px solid #eee  ',
                            }}
                            onClick={() => this.toggleAddReceiptModal(cp)}
                          >
                            {'Neuer Beleg'}
                          </div>
                          }
                          onClickForEmpty={()=> this.setState({selectReceiptsForReceiptAssigmentModalOpen: true, 
                          selectedReceiptsForReceiptAssignments: this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))),
                          selectedHeatingCostForReceiptAssignments: cp.heatingCostType, runUpdateReceiptAssignmentsByCostPositionId: cp.id,
                          currentCp: cp})}
                          launchIconOnClick={()=> this.setState({selectReceiptsForReceiptAssigmentModalOpen: true, selectedReceiptsForReceiptAssignments: this.state.receipts.filter((receipt) => cp.assignedReceipts.find((selected) => (selected.costPositionId === cp.id && selected.receiptId === receipt.id))),
                          selectedHeatingCostForReceiptAssignments: cp.heatingCostType,
                          runUpdateReceiptAssignmentsByCostPositionId: cp.id,
                          currentCp: cp})}
                        />}
                      </div>
                    </TableCell>
                    <TableCell className='pr-0'>
                      {cp.systemHeatingCostTypeId !== co2TaxReturnLandlordShareSystemId &&
                      <button disabled={utilityData.isSecured} style={{ cursor: utilityData.isSecured ? 'not-allowed' : 'pointer' }} 
                      onClick={() => {
                        if(utilityData.isSecured === false){
                          if(cp.assignedReceipts.length > 0){
                            const assignedReceiptsForDeletion = cp.assignedReceipts.map((receiptAssignment)=> ({id: receiptAssignment.receiptId, utilityBillingRelevant: false}));
                            this.setState({openRemoveReceiptAssignmentForCpDeleteModal: true, selectedHeatingCostPositionForDeletionId: cp.id, selectedHeatingCostPositionAssignedReceiptsForDeletion: assignedReceiptsForDeletion});
                          }else{
                            this.deleteHeatingCost(cp.id);
                          }
                        }
                      }} 
                      type="button" class={`close ${utilityData?.isSecured ? 'delete-cost-position-disabled' : 'delete-cost-position'}`} aria-label="Close"><span aria-hidden="true">×</span></button>}
                    </TableCell>
                  </TableRow>
                </>
                )})
              )}
                {(this.state.costPositions.length === 0 || (!isCO2TaxActivated || !this.state.costPositions.some(cp => cp.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId))) && !heatingCostsLoader && renderAddCostPositionRow()}
                <TableRow>
                  <TableCell className='pl-0'>
                    <Group className='total-heating-cost-label' style={{marginTop: '1px'}} justify='right'>
                      <span style={{fontSize: '14px', color: 'rgb(14, 14, 29)', fontWeight: '400'}}>{lang.utility.text_total_costs}</span>
                    </Group>
                  </TableCell>
                  <TableCell>
                    <Group wrap="nowrap" gap={10} justify='center' align={'center'}>
                      <NumericFormat 
                      className={`form-control`}
                      value={totalCost.value}
                      thousandSeparator="." 
                      decimalSeparator=","
                      onValueChange={(values, sourceInfo) => {
                        this.onInputChange('totalCost', values.floatValue)
                      }}
                      onKeyPress={this.handleEnterKeyPress}
                      placeholder='0,00 €'
                      suffix=' €'
                      style={{textAlign: 'right'}}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={true}
                      disabled={true}
                      />
                      <Group wrap="nowrap" gap={10} style={{visibility: 'hidden'}}>
                        <div className={'sub-text-ub-costposition-amount-disabled'}>
                          Mwst
                        </div>
                        <div className={'sub-text-ub-costposition-amount-disabled'}>
                          Lohn
                        </div>
                      </Group>
                    </Group>
                  </TableCell>
                </TableRow>
              </So>
            </Table>
          </TableContainer> */}
          
          <div className="cp-cost-icons" style={{marginTop: '20px'}}>
            <p className="heating-cost-text ub-heating-cost-modal-energy-consumption">{lang.utility.text_Energy_consumption}</p>
          </div>
          <Row>
            <Col xs={6}>
              <Form.Group>
                <Form.Label className="cp-cost-position-label"> {lang.newKeys.text_Consumption_type} </Form.Label>
                <UncontrolledDropdown
                  id="keyid2"
                  onBlur={() => {
                    this.setState({
                      dropdownStateTwo: document
                        .getElementById('keyid2')
                        .firstElementChild.getAttribute('aria-expanded'),
                    });
                  }}
                  onFocus={() => {
                    this.setState({
                      dropdownStateTwo: document
                        .getElementById('keyid2')
                        .firstElementChild.getAttribute('aria-expanded'),
                    });
                  }}
                >
                  <DropdownToggle className={`dropdown-select form-control ${selectedEnergyErr && 'invalid'}`} disabled={utilityData.isSecured}>
                    <span> {this.state.selectedEnergy.fuelTypeName}</span>
                    <span>
                      {' '}
                      {this.state.dropdownStateTwo === 'true' ? (
                        <img src={downArrow} alt="" />
                      ) : (
                        <img src={uparrow} alt="" />
                      )}
                    </span>
                  </DropdownToggle>
                  <DropdownMenu className="cp-menu">
                    {this.state.energyOptions.sort((a,b)=> a.fuelTypeName > b.fuelTypeName).sort((a,b)=> { return a.fuelTypeName === 'Energieverbrauch (kWh)' ? -1 : b.fuelTypeName === 'Energieverbrauch (kWh)' ? 1 : 0 })
                    .map((option) => (
                      <DropdownItem
                        onClick={() => {
                          this.energyChange(option);
                        }}
                        className="cpRow-options"
                      >
                        <span className=" ">{option.fuelTypeName}</span>
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
                {!selectedEnergy.fuelTypeName && selectedEnergyErr && <span style={{
                  width: '100%',
                  marginTop: '0.25rem',
                  fontSize: '80%',
                  color: '#dc3545'
                  }}>Energieträger erforderlich</span>}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group>
                <Form.Label className="cp-amount-label"> {lang.utility.text_Consumption} </Form.Label>
                <NumericFormat 
                  className={`form-control ${utilityData?.isSecured && 'disabled'}`}
                  value={this.state.amount.value}
                  thousandSeparator="." 
                  decimalSeparator=","
                  onValueChange={(values, sourceInfo) => {
                    this.onInputChange('amount', values.floatValue);
                  }}
                  onKeyPress={this.handleEnterKeyPress}
                  placeholder='0,00'
                  onFocus={()=> this.setState({energyConsumptionInFocus: true})}
                  onBlur={(e)=> {
                    if(isCO2TaxActivated === true){
                      const {selectedEnergy} = this.state;
                      let value = accounting.unformat(e.target.value, ',');
                      let totalCO2Emissions = this.calculateTotalCO2Emissions(value, selectedEnergy);
                      console.log('calculateTotalCO2Emissions: ', totalCO2Emissions, selectedEnergy, selectedEnergy.fuelTypeName === 'Heizleistung (kWh)');
                      this.setState({totalCO2Emissions}, ()=> this.postCO2TaxReimbursementValue());  
                    }
                    this.setState({energyConsumptionInFocus: false});
                  }}
                  decimalScale={energyConsumptionInFocus ? 5 : 2}
                  fixedDecimalScale={energyConsumptionInFocus ? false : true}
                  allowNegative={false}
                  disabled={utilityData.isSecured}
                />
                <Form.Control.Feedback className="err" type="invalid">
                  {amount.msg}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          {propertySelected.heatingType === 'central with warm water' &&
            <><div className="cp-cost-icons" style={{marginTop: 20}}>
            <p className="heating-cost-text ub-heating-cost-modal-heat-quantity-hot-water">{lang.utility.text_heat_quantity_hot_water_boiler}</p>
          </div>  
          <Row>
            <Col xs={6}>
              <Form.Group>
                <Form.Label className="cp-cost-position-label"> {lang.newKeys.text_unit} </Form.Label>
                <UncontrolledDropdown
                  id="keyid2"
                  onBlur={() => {
                    this.setState({
                      dropdownStateTwo: document
                        .getElementById('keyid2')
                        .firstElementChild.getAttribute('aria-expanded'),
                    });
                  }}
                  onFocus={() => {
                    this.setState({
                      dropdownStateTwo: document
                        .getElementById('keyid2')
                        .firstElementChild.getAttribute('aria-expanded'),
                    });
                  }}
                >
                  <DropdownToggle disabled={utilityData.isSecured || this.state.checkboxone} className={`dropdown-select form-control ${selectedAllocationErr && 'invalid'}`}>
                    <span>
                      <span style={{minWidth: 0, overflow: 'hidden', whiteSpace:'nowrap', textOverflow: 'ellipsis'}}> {this.state?.selectedAllocation?.allocationKeyName}</span>
                      <span style={{paddingRight: 10}}> {this.state?.selectedAllocation?.units && this.state?.selectedAllocation?.units !== '-' ? `(${this.state?.selectedAllocation?.units})` : ''}</span>
                    </span>
                    <span>
                      {' '}
                      {this.state.dropdownStateTwo === 'true' ? (
                        <img src={downArrow} alt="" />
                      ) : (
                        <img src={uparrow} alt="" />
                      )}
                    </span>
                  </DropdownToggle>
                  <DropdownMenu className="cp-menu">
                    {this.state.allocationOptions.map((option) => option.type === 'WARMWATER' && option.allocationKeyName !== 'Warmwasserverbrauch' && (
                      <DropdownItem
                        onClick={() => {
                          this.allocationChange(option);
                        }}
                        className="cpRow-options"
                      >
                        {console.log('option: ', option)}
                        <span className=" ">{`${option.allocationKeyName} ${option.units && option.units !== '-' ? `(${option.units})` : ''}`}</span>
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
                {!selectedAllocation?.allocationKeyName && selectedAllocationErr && !this.state.checkboxone && <span style={{
                  width: '100%',
                  marginTop: '0.25rem',
                  fontSize: '80%',
                  color: '#dc3545'
                  }}>Einheit erforderlich</span>}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group>
                <Form.Label className="cp-amount-label"> {lang.utility.text_Consumption} </Form.Label>
                <NumericFormat 
                  className={`form-control ${utilityData?.isSecured && 'disabled'}`}
                  value={this.state.unitAmount.value}
                  thousandSeparator="." 
                  decimalSeparator=","
                  onValueChange={(values, sourceInfo) => {
                    this.onInputChange('unitAmount', values.floatValue);
                  }}
                  onKeyPress={this.handleEnterKeyPress}
                  placeholder='0,00'
                  onFocus={()=> this.setState({waterHeatConsumptionInFocus: true})}
                  onBlur={()=> this.setState({waterHeatConsumptionInFocus: false})}
                  decimalScale={waterHeatConsumptionInFocus ? 5 : 2}
                  fixedDecimalScale={waterHeatConsumptionInFocus ? false : true}
                  allowNegative={false}
                  disabled={utilityData.isSecured || this.state.checkboxone}
                />
                <Form.Control.Feedback className="err" type="invalid">
                  {unitAmount.msg}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Form.Group controlId="formBasicCheckboxOne" className="form-check-box">
                <Checkbox
                  checked={this.state.checkboxone}
                  onClick={() => {
                    this.state.checkboxone ? this.setState({checkboxone: false, selectedAllocation: propertySelected.centralWarmWaterAllocationKey}) : this.setState({checkboxone: true, openAlert: true})
                  }}
                  style={{
                    lineHeight: '22px',
                    color: this.state.checkboxone ? '#5555FF' : '#9A9AB5',
                    opacity: utilityData?.isSecured ? 0.5 : 1,
                    background: utilityData?.isSecured && '#f7f7fa',
                    padding: 0,
                    borderRadius: 0,
                    width: '14px',
                    height: '14px',
                    marginLeft: '1px'
                  }}
                  disabled={utilityData.isSecured}
                />
                <Form.Label className="cp-amount-label ub-heating-cost-modal-disable-heat-quantity-hot-water" style={{marginLeft: '8px'}}>kein Verbrauch verfügbar</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          </>}
          {(dayjs(billingPeriod?.endDate).year() >= 2023) &&
          <>
            <div className="cp-cost-icons" style={{marginTop: '15px'}}>
              <p className="heating-cost-text ub-heating-cost-modal-co2-tax"><span>CO<span style={{verticalAlign: 'sub', fontSize: '8px'}}>2</span>-Steuer</span></p>
            </div>
            <Row style={{marginTop: '-5px'}}>
              <Col xs={6}>
                <Form.Group>
                  <Form.Label className="cp-amount-label">
                    <span>CO<span style={{verticalAlign: 'sub', fontSize: '8px'}}>2</span>-Emissionen</span> {isCO2TaxActivated && <span className='required-aesteric'>*</span>}
                  </Form.Label>
                  <NumericFormat 
                    className={`form-control ${utilityData?.isSecured && 'disabled'} ${(co2EmissionErr && this.checkCO2EmissionEmpty()) && 'is-invalid'}`}
                    value={totalCO2Emissions}
                    thousandSeparator="." 
                    decimalSeparator=","
                    onValueChange={(values, sourceInfo) => {
                      if(isCO2TaxActivated === true){
                        this.setState({totalCO2Emissions: values.floatValue});
                      }
                    }}
                    onKeyPress={this.handleEnterKeyPress}
                    onBlur={(e)=> {
                      console.log('onBlur: ', e.target.value);
                      let value = e.target.value;
                      if(!value){
                        let totalCO2Emissions = this.calculateTotalCO2Emissions(this.state.amount.value, selectedEnergy);
                        console.log('onBlur: ', totalCO2Emissions);
                        this.setState({totalCO2Emissions}, ()=> this.postCO2TaxReimbursementValue());
                      }else{
                        this.postCO2TaxReimbursementValue();
                      }
                    }}
                    placeholder='0,00 kg'
                    suffix={' kg'}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    disabled={utilityData.isSecured || (isCO2TaxActivated === false)}
                  />
                  {(co2EmissionErr && this.checkCO2EmissionEmpty()) && <span className='g-error-message'>Angabe notwendig (oder keine CO<span style={{verticalAlign: 'sub', fontSize: '8px'}}>2</span>-Steuer ausweisen aktivieren)</span>}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group controlId="formBasicCheckboxOne" style={{marginBottom: '5px'}} className="form-check-box">
                  <Checkbox
                    checked={isCO2TaxMainlyUsedForBusiness}
                    onClick={() => this.setState({isCO2TaxMainlyUsedForBusiness: !isCO2TaxMainlyUsedForBusiness}, ()=> this.postCO2TaxReimbursementValue())}
                    style={{
                      lineHeight: '22px',
                      color: isCO2TaxActivated === false ? (isCO2TaxMainlyUsedForBusiness ? '#5555FF' : '#dadae6') : (isCO2TaxMainlyUsedForBusiness ? '#5555FF' : '#9A9AB5'),
                      padding: 0,
                      opacity: utilityData?.isSecured ? 0.5 : isCO2TaxActivated === false ? (isCO2TaxMainlyUsedForBusiness ? 0.5 : 1) : 1,
                      background: isCO2TaxActivated === false && '#f7f7fa',
                      borderRadius: 0,
                      width: '14px',
                      height: '14px',
                      marginLeft: '1px'
                    }}
                    disabled={utilityData.isSecured || (isCO2TaxActivated === false)}
                  />
                  <Form.Label className="cp-amount-label ub-heating-cost-modal-co2-tax-property-commercial-tenants-check" style={{marginLeft: '8px'}}>Immobilie überwiegend an Gewerbe vermietet</Form.Label>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group controlId="formBasicCheckboxOne" style={{marginBottom: '5px'}} className="form-check-box">
                  <Checkbox
                    checked={isCO2TaxPreservationObject}
                    onClick={() => this.setState({isCO2TaxPreservationObject: !isCO2TaxPreservationObject}, ()=> this.postCO2TaxReimbursementValue())}
                    style={{
                      lineHeight: '22px',
                      color: isCO2TaxActivated === false ? (isCO2TaxPreservationObject ? '#5555FF' : '#dadae6') : (isCO2TaxPreservationObject ? '#5555FF' : '#9A9AB5'),
                      padding: 0 ,
                      opacity: utilityData?.isSecured ? 0.5 : isCO2TaxActivated === false ? (isCO2TaxPreservationObject ? 0.5 : 1) : 1,
                      background: isCO2TaxActivated === false && '#f7f7fa',
                      borderRadius: 0,
                      width: '14px',
                      height: '14px',
                      marginLeft: '1px'
                    }}
                    disabled={utilityData.isSecured || (isCO2TaxActivated === false)}
                  />
                  <Form.Label className="cp-amount-label ub-heating-cost-modal-co2-tax-property-preservation-check" style={{marginLeft: '8px'}}>Immobilie unter Denkmalschutz / Erhaltungssatzung</Form.Label>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group controlId="formBasicCheckboxOne" className="form-check-box">
                  <Checkbox
                    checked={isCO2TaxActivated === false}
                    onClick={() => {
                      if(!isCO2TaxActivated === true) {
                        const {selectedEnergy} = this.state;
                        let totalCO2EmissionsUpdated = this.calculateTotalCO2Emissions(amount.value, selectedEnergy, !isCO2TaxActivated);
                        this.setState({isCO2TaxActivated: !isCO2TaxActivated, totalCO2Emissions: !totalCO2Emissions ? totalCO2EmissionsUpdated : totalCO2Emissions}, ()=> this.postCO2TaxReimbursementValue(()=> this.calculateTotalOnAmountChange()));
                      }else{
                        this.setState({isCO2TaxActivated: !isCO2TaxActivated, totalCO2Emissions: ''}, ()=> this.removalOfCO2TaxReimbursementCostPosition());
                      }
                    }}
                    style={{
                      lineHeight: '22px',
                      color: isCO2TaxActivated === false ? '#5555FF' : '#9A9AB5',
                      opacity: utilityData?.isSecured ? 0.5 : 1,
                      padding: 0,
                      borderRadius: 0,
                      width: '14px',
                      height: '14px',
                      marginLeft: '1px'
                    }}
                    disabled={utilityData.isSecured}
                  />
                  <Form.Label className="cp-amount-label ub-heating-cost-modal-co2-tax-disable-co2-tax-check" style={{marginLeft: '8px'}}>keine C0<span style={{verticalAlign: 'sub', fontSize: '8px'}}>2</span>-Steuer ausweisen</Form.Label>
                </Form.Group>
              </Col>
            </Row>
          </>}
          <Row>
            <Col xs={12}>
              <span className="navigate-button" onClick={(e) => {
                e.preventDefault();
                this.setState({openRedirectAlert: true});
                }}><img src={UpRightArrow} style={{width: '10px', height: '10px', marginRight: '5px', marginTop: '-2px'}}/>{'Klicken Sie hier, um zu den Grundeinstellungen der Heizungsanlage zu gelangen.'}
              </span>
            </Col>
          </Row>
          <div className="cancel_add_btn_container">
            <div>
              <ColorButton
                onClick={(e) => {
                  e.preventDefault();
                  this.resetForm();
                  toggle();
                }}
                className="gray-btn"
                text={lang.general.text_cancel}
              />
            </div>
            <div>
              <ColorButton
                buttonConfig={{ type: 'submit' }}
                className="purple-btn cp-btn"
                text={lang.meter.text_save}
                disabled={utilityData.isSecured}
              />
            </div>
          </div>
        </Form>
        {addHeatingCostModalOpen &&
        <AddHeatingCostModal
        open={addHeatingCostModalOpen}
        toggle={() => this.setState({addHeatingCostModalOpen: false})}
        saveHeatingCost={(heatingCost) => this.setState({addHeatingCostModalOpen: false}, ()=> this.saveHeatingCost(heatingCost))}
        />}

        {openEditVatAndLabourAmount &&
        <EditVatAndLabourAmount
        vatAmount={selectedHCPforVATlabourEdit?.vatAmount}
        laborCost={selectedHCPforVATlabourEdit?.laborCost}
        isSecured={utilityData.isSecured}
        resetValuesToDefault={resetValuesToDefault}
        setResetValuesToDefault={()=> this.setState({resetValuesToDefault: false})}
        hideAndDisableForCO2Tax={selectedHCPforVATlabourEdit?.systemHeatingCostTypeId === co2TaxReturnLandlordShareSystemId}
        open={openEditVatAndLabourAmount}
        toggle={()=> this.setState({openEditVatAndLabourAmount: false, selectedHCPforVATlabourEdit: null})}
        openRemoveReceiptAssignmentForCpAmountModal={(vatAmount, laborCost)=> {
          if(this.state.receipts.filter((receipt) => selectedHCPforVATlabourEdit.assignedReceipts.find((selected) => (selected.costPositionId === selectedHCPforVATlabourEdit.id && selected.receiptId === receipt.id))).length > 0){
            this.setState({
              openRemoveReceiptAssignmentForCpAmountModal: true, 
              removedItems: this.state.receipts.filter((receipt) => selectedHCPforVATlabourEdit.assignedReceipts.find((selected) => (selected.costPositionId === selectedHCPforVATlabourEdit.id && selected.receiptId === receipt.id))),
              newVatAmount: vatAmount,
              newLaborCost: laborCost
            });  
          }else{
            this.saveNewVatAmountAndLaborCost(vatAmount, laborCost);
          }
        }}
        />}

          {openRemoveReceiptAssignmentModal &&
          <ReceiptAssigmentRemoveConfirmationModal
          open={openRemoveReceiptAssignmentModal}
          //newAmount={newAmount}
          history={this.props.history}
          toggle={()=> this.setState({openRemoveReceiptAssignmentModal: false})}
          removeReceipt={()=> this.setState({heatingCostsLoader: true},()=> this.updateReceipt())}
          />}

          {openRemoveReceiptAssignmentForCpAmountModal &&
          <ReceiptAssigmentRemoveConfirmationForCpAmountModal
          open={openRemoveReceiptAssignmentForCpAmountModal}
          //newAmount={newAmount}
          toggle={()=> {
            if(selectedHCPforAmountEdit || selectedHCPforVATlabourEdit){
              let updatedSelectedHCPforVATlabourEdit = selectedHCPforVATlabourEdit;
              let newResetValuesToDefault = resetValuesToDefault;
              let newCostPositions= costPositions.map((cp)=> {
                console.log('selectedHCPforVATlabourEdit: toggle: ', selectedHCPforVATlabourEdit, selectedHCPforAmountEdit, previousLaborCost, previousVatAmount, cp);
                if(cp.id === selectedHCPforAmountEdit?.id){
                  if(previousAmount){
                    cp.heatingCost = previousAmount;
                  }
                  if(previousLaborCost){
                    cp.laborCost = previousLaborCost;
                  }
                  if(previousVatAmount){
                    cp.vatAmount = previousVatAmount;
                  }
                }
                if(cp.id === selectedHCPforVATlabourEdit?.id){
                  if(previousLaborCost){
                    updatedSelectedHCPforVATlabourEdit.laborCost = previousLaborCost;
                    cp.laborCost = previousLaborCost;
                    newResetValuesToDefault = true;
                  }
                  if(previousVatAmount){
                    updatedSelectedHCPforVATlabourEdit.vatAmount = previousVatAmount;
                    cp.vatAmount = previousVatAmount;
                    newResetValuesToDefault = true;
                  }
                }
                return cp;
              });
              this.setState({newCostPositions, selectedHCPforVATlabourEdit: updatedSelectedHCPforVATlabourEdit, resetValuesToDefault: newResetValuesToDefault});
            }
            this.setState({openRemoveReceiptAssignmentForCpAmountModal: false})
          }}
          removeReceipt={()=> this.setState({heatingCostsLoader: true},()=> this.updateReceipt())}
          />}

        {openRemoveReceiptAssignmentForCpDeleteModal &&
        <ReceiptAssigmentRemoveConfirmationForCpDeleteModal
        open={openRemoveReceiptAssignmentForCpDeleteModal}
        toggle={()=> this.setState({openRemoveReceiptAssignmentForCpDeleteModal: false})}
        removeReceipt={()=> this.setState({removedItems: selectedHeatingCostPositionAssignedReceiptsForDeletion, openRemoveReceiptAssignmentForCpDeleteModal: false},()=> this.updateReceipt(null, null, true))}
        />}

        {selectReceiptsForReceiptAssigmentModalOpen &&
        <SelectReceiptsForReceiptAssigmentModal
        edit={false}
        isSecured={utilityData?.isSecured}
        open={selectReceiptsForReceiptAssigmentModalOpen}
        currentCp={currentCp}
        receiptsLoader={receiptsLoader || heatingCostsLoader}
        receipts={this.state.receipts.filter((receipt)=> receipt.heatingCostType === selectedHeatingCostForReceiptAssignments).map((receipt)=> {
          receipt.receiptDate= receipt.receiptDate.includes('T') ? receipt.receiptDate : `${dayjs(receipt.receiptDate, 'DD.MM.YYYY').format('YYYY-MM-DD')}T00:00:00`;
          return receipt;
        })}
        toggle={()=> this.setState({selectReceiptsForReceiptAssigmentModalOpen: false, selectedHeatingCostForReceiptAssignments: null, selectedReceiptsForReceiptAssignments: [], runUpdateReceiptAssignmentsByCostPositionId: null, currentCp: null})}
        selectedReceiptsFromParent={selectedReceiptsForReceiptAssignments.map((receipt)=> receipt.id)}
        openAddReceiptModal={()=> this.toggleAddReceiptModal(currentCp)}
        removeReceipt={(receiptId)=> {
          let {receipts} = this.state;
          receipts = receipts.filter((receipt)=> receipt.id !== receiptId);
          this.setState({receipts});
        }}
        updateReceipt={(updatedReceipt)=> {
          let {receipts} = this.state;
          receipts = receipts.map((receipt)=> {
            if(receipt.id === updatedReceipt.id){
              receipt= {...receipt, ...updatedReceipt};
            }
            return receipt;
          });
          this.setState({receipts, runUpdateReceiptAssignmentsByCostPositionId: currentCp.id}, ()=> this.updateReceiptAssignmentsByCostPositionId(false));
        }}
        saveSelectedReceipts={(selectedReceipts)=> this.setState({selectReceiptsForReceiptAssigmentModalOpen: false}, ()=> {
          let selectedReceiptsListOfObjects= this.state.receipts.filter((receipt)=> selectedReceipts.find((receiptId)=> receipt.id === receiptId) !== undefined);
          let receiptsAdded = selectedReceiptsListOfObjects.filter((receipt)=> selectedReceiptsForReceiptAssignments.find((selected) => (selected.id === receipt.id)) === undefined);
          let receiptsRemoved = selectedReceiptsForReceiptAssignments.filter((selected)=> selectedReceipts.find((receiptId) => (selected.id === receiptId)) === undefined);
          receiptsAdded = receiptsAdded.map((receipt)=> {
            return{
              id: receipt.id,
              utilityBillingRelevant: true
            }
          });

          receiptsRemoved = receiptsRemoved.map((receipt)=> {
            return{
              id: receipt.id,
              utilityBillingRelevant: false
            }
          });

          let allReceiptsCombinedForUpdate= [...receiptsAdded, ...receiptsRemoved];
          console.log('receiptsAdded, receiptsRemoved: ', receiptsAdded, receiptsRemoved, allReceiptsCombinedForUpdate);
          if(allReceiptsCombinedForUpdate.length > 0){
            this.setState({heatingCostsLoader: true}, ()=> this.putReceipts(allReceiptsCombinedForUpdate, true)
            );
          }
          
        })}
        />}
      </CustomModal>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currentDataId: state.UtilityBillingReducer.currentBillingId,
    propertySelected: state.generalReducer.property,
  };
};
const actions = {
  changeCurrentProperty,
  setRunUpdateHeatingCostSplit
};
export default connect(mapStateToProps, actions)(HeatingCostModal);